import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../assets/background.png";
import Newsletter from "./newsLetter";
import historyImage1 from "../assets/history1.png";
import gamalielImg from "../assets/gamaliel.png";
import backgroundImage1 from "../assets/aboutUsback.png";

const AboutUs = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [loadingVideo, setLoadingVideo] = useState(true);
  const [error, setError] = useState(null);
  const [ourStaffs, setOurStaffs] = useState([]);
  const navigate = useNavigate();

  const [clickedCardIndex, setClickedCardIndex] = useState(null);

  const handleSvgClick = (index) => {
    setClickedCardIndex(clickedCardIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchStaffs = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/staffs?populate=*`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        console.log(data.data)
        setOurStaffs(data.data);
      } catch (error) {
        console.error("Error fetching staffs:", error);
      }
    };

    fetchStaffs();
  }, []);

  const handleViewMoreClick = () => {
    window.scrollTo(0, 0);
    navigate("/leadership");
  };

  const faqItems = [
    {
      question: "01. ⁠How to contact us?",
      answer: "You can contact us by hone: 217-544-2297 and by email: info@faithcoalition-il.org",
    },
    {
      question: "02. Who I the executive director",
      answer: "Tyshianna Bankhead email: tyshianna@faithcoalition-il.org",
    },
    {
      question: "03. ⁠Where are we located?",
      answer: "2208 E Kansas St, Springfield Illinois 62703)",
    },
  ];

  const toggleOpen = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const images = [historyImage1];
  const content = [
    {
      year: "2005",
      title: "Foundation of the Faith Coalition for the Common Good",
      description:
        "Established by dedicated faith and community leaders to address social injustices and promote the common good in central Illinois.",
    },
    {
      year: "2007",
      title: "Launch of First Community Outreach Program",
      description:
        "Initiated programs focusing on racial equity, marking the beginning of active community engagement and support.",
    },
    {
      year: "2010",
      title: "Introduction of the Civic Engagement Initiative",
      description:
        "Started efforts to encourage and facilitate active civic participation among community members.",
    },
    {
      year: "2012",
      title: "Expansion into Educational Programs",
      description:
        "Conducted community workshops to enhance educational opportunities and support lifelong learning.",
    },
    {
      year: "2015",
      title: "Successful Advocacy for Local Policy Change",
      description:
        "Achieved a significant victory in local policy reform, reflecting the coalition's growing influence and impact.",
    },
    {
      year: "2018",
      title: "10,000 Volunteer Hours Milestone",
      description:
        "Reached an impressive milestone of 10,000 volunteer hours, showcasing the dedication and commitment of our supporters.",
    },
    {
      year: "2020",
      title: "Virtual Engagement Programs",
      description:
        "Launched virtual programs to continue community engagement and support during the COVID-19 pandemic.",
    },
  ];

  const handleNext = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === content.length - 1 ? 0 : prevIndex + 1
      );
      setIsTransitioning(false);
    }, 300);
  };

  const handlePrev = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? content.length - 1 : prevIndex - 1
      );
      setIsTransitioning(false);
    }, 300);
  };

  const getBackgroundColor = (year) => {
    switch (year) {
      case "2005":
      case "2012":
      case "2020":
        return "rgba(230, 207, 242, 1)";
      case "2007":
        return "rgba(255, 229, 182, 1)";
      case "2010":
      case "2015":
        return "rgba(210, 243, 224, 1)";
      case "2018":
        return "rgba(255, 229, 182, 1)";
      default:
        return "rgba(230, 207, 242, 1)";
    }
  };

  // useEffect(() => {
  //   const fetchVideo = async () => {

  //     try {
  //       const response = await fetch(
  //         "https://brave-desire-25bf4107de.strapiapp.com/api/about-us?populate=*",
  //         {
  //           headers: {
  //             Authorization: `Bearer `,
  //           },
  //         }
  //       );

  //       if (!response.ok) {
  //         throw new Error("Failed to fetch video.");
  //       }

  //       const blob = await response.blob();
  //       const url = URL.createObjectURL(blob);
  //       setVideoUrl(url);
  //     } catch (err) {
  //       console.error("Error fetching video:", err);
  //       setError(err);
  //     } finally {
  //       setLoadingVideo(false);
  //     }
  //   };

  //   fetchVideo();

  //   // Cleanup: Revoke the object URL to free memory
  //   return () => {
  //     if (videoUrl) {
  //       URL.revokeObjectURL(videoUrl);
  //     }
  //   };
  // }, []);

  const fetchVideoUrl = useCallback(async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/about-us?populate=about_us_video`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`, // Ensure this token has correct permissions
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch video data.");
      }

      const data = await response.json();
      const videoData = data.data.attributes.about_us_video.data.attributes.url;

      const fullVideoUrl = videoData.startsWith("http")
        ? videoData
        : `${process.env.REACT_APP_BASE_URL}${videoData}`;

      setVideoUrl(fullVideoUrl);
    } catch (err) {
      console.error("Error fetching video URL:", err);
      setError(err);
    } finally {
      setLoadingVideo(false);
    }
  }, []);

  useEffect(() => {
    fetchVideoUrl();
  }, [fetchVideoUrl]);

  return (
    <>
      <div>
        {/* Header Section */}
        <div
          className="w-full h-auto mt-[84px] mx-auto sm:max-w-[1200px] pt-4 sm:pt-[75px] pr-4 pb-4 sm:pb-[94px] pl-4 bg-no-repeat bg-center bg-cover bg-[position:50%_1%]"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        >
          <div className="w-full h-auto flex flex-col opacity-100 mx-auto px-4">
            {/* Header */}
            <div className="flex items-center mb-4">
              <div className="w-[72px] h-0 border-t-2 border-custom-orange mr-6"></div>
              <span className="font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-custom-orange">
                ABOUT US
              </span>
            </div>
            {/* Title */}
            <h1 className="font-primary text-[40px] md:text-[64px] font-bold leading-[48px] md:leading-[76.8px] text-custom-blue m-0">
              We are here to make a transformative impact on the community.
            </h1>
          </div>
        </div>
        <div
          className="relative max-w-[1200px] mx-auto px-4 mb-5"
          style={{ marginTop: "-50px" }}
        >
          <div className="flex justify-center">
            {loadingVideo ? (
              <div className="flex justify-center items-center text-custom-blue">
                <svg
                  className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-custom-orange rounded-full"
                  viewBox="0 0 24 24"
                ></svg>
                Loading video...
              </div>
            ) : error ? (
              <div className="text-center text-red-500">
                Error loading video.
                <button
                  onClick={() => {
                    setLoadingVideo(true);
                    setError(null);
                    setVideoUrl("");
                    fetchVideoUrl();
                  }}
                  className="mt-2 text-custom-orange underline"
                >
                  Retry
                </button>
              </div>
            ) : (
              <div className="w-full max-w-[1200px] aspect-w-16 aspect-h-9 rounded-[20px] bg-white overflow-hidden mx-auto">
                <video
                  src={videoUrl}
                  controls
                  className="w-full h-full object-contain"
                  preload="metadata"
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            )}
          </div>
        </div>

        <div className="w-full h-auto bg-[#FFF2DB] z-0">
          <div
            className="w-full  h-auto md:h-[540px] max-w-[1200px] mx-auto pt-6 pb-12 md:pt-[50px] md:pb-[50px] px-6 lg:px-[120px] gap-10 flex flex-col md:flex-row justify-between mx-auto"
            style={{
              backgroundImage: `url(${backgroundImage1})`,
              backgroundSize: "contain",
              backgroundPosition: "top -200px left 0",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="w-full md:w-[585px] h-auto">
              <div className="flex items-center mb-4">
                <div className="w-[72px] h-0 border-t-2 border-custom-orange mr-6"></div>
                <span className="font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-custom-orange">
                  OUR MISSION
                </span>
              </div>

              <h2 className="font-primary text-[32px] md:text-[42px] font-bold leading-[40px] md:leading-[50.4px] text-[#002A57] mb-6">
                Collaborative Efforts for Racial Equity and Civic Engagement
              </h2>

              <p className="font-secondary text-[16px] font-normal leading-[25.6px] text-[#433E3F] mb-6">
                We are a coalition of faith communities, community
                organizations, and individuals working together to promote
                racial equity, civic engagement, a fair economy, and
                participatory decision-making.
              </p>

              <div className="w-[152px] h-[48px] bg-[#002A57] rounded-[30px] flex items-center justify-center cursor-pointer">
                <span className="font-primary text-[14px] font-medium leading-[18px] text-white">
                  Invest Now
                </span>
              </div>
            </div>

            <div className="w-full md:w-[568px] h-[300px] md:h-[440px] rounded-[20px] mt-8 md:mt-0">
              <img
                src={require("../assets/aboutUs2.png")}
                alt="About Us"
                className="w-full h-full object-cover rounded-[20px]"
              />
            </div>
          </div>
        </div>

        <div className="relative w-full max-w-[1200px] h-auto px-4 md:px-[50px] py-[50px] mx-auto flex justify-center items-center">
          <div className="w-full max-w-[740px] h-auto flex flex-col items-center gap-8">
            <div className="w-full h-[22px] font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-center text-custom-orange">
              OUR AFFILIATION
            </div>
            <div className="w-full max-w-[311px] h-[51px] flex justify-center">
              <img
                src={gamalielImg}
                alt="Gamaliel"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="w-full font-secondary text-[16px] font-normal leading-[25.6px] text-center text-custom-lightgray">
              We are affiliated with Gamaliel of Illinois/Iowa and the National
              Gamaliel Network. Through community organizing and leadership
              training, our members become powerful leaders, address issues of
              injustice, and fight for positive systemic change.
            </div>
          </div>
        </div>
      </div>

      {/* <div className="relative w-full max-w-[1440px] h-auto px-[120px] py-[50px] mx-auto box-border">
      <div className="w-full max-w-[1200px] h-auto mx-auto">
        <div className="flex flex-col items-start gap-[10px]">
          <div className="w-[115px] h-[22px] font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-custom-orange" style={{ whiteSpace: "nowrap" }}>
            OUR IMPACT
          </div>
          <div className="mt-[10px] w-[534px] h-[38px] font-primary text-[32px] font-bold leading-[38.4px] text-custom-blue" style={{ whiteSpace: "nowrap" }}>
            How do we help?
          </div>
        </div>
        <div className="flex justify-center gap-[30px] mt-[50px]">
          <div className="w-[380px] h-[339px] border border-neutral-100 rounded-[20px] flex flex-col p-[20px]">
            <div className="flex flex-col items-left gap-[8px]">
              <div style={{ marginBottom: "50.9px" }}>
              <svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_294_12106" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="65">
                  <path d="M0 0H64V64.1H0V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_294_12106)">
                  <path d="M53.1 22.635V13.7211C54.3 13.3205 55.1 12.2188 55.1 10.9167V9.91516H53.1V10.9167C53.1 11.5177 52.7 11.9183 52.1 11.9183C51.5 11.9183 51.1 11.5177 51.1 10.9167C51.1 9.21407 49.8 7.91204 48.1 7.91204H36.2V6.30954L32.1 0.0998535L28 6.30954V7.81188H16C14.3 7.81188 13 9.11391 13 10.8166C13 11.4175 12.6 11.8181 12 11.8181C11.4 11.8181 11 11.4175 11 10.8166V9.81501H9V10.8166C9 12.1186 9.8 13.2203 11 13.6209V22.5348L0 42.5661V42.8666C0 46.7727 3.1 49.8775 7 49.8775H17C20.9 49.8775 24 46.7727 24 42.8666V42.5661L13 22.5348V13.6209C14.2 13.2203 15 12.1186 15 10.8166C15 10.2156 15.4 9.81501 16 9.81501H28.1V11.8181H31V14.0216C29.3 14.5224 28.1 16.0247 28.1 17.8275C28.1 19.6303 29.3 21.2328 31 21.6334V24.0372C29.3 24.538 28 26.0403 28 27.8431V47.5739L30.4 48.7758L26 54.1842V55.8869C22.6 56.3877 20 59.3923 20 62.8978V63.8994H44V62.8978C44 59.3923 41.4 56.4878 38.1 55.8869V54.0841L33.5 48.7758L36.1 47.5739L36 27.8431C36 25.9402 34.7 24.4378 33 24.0372V21.8338C34.8 21.5333 36.2 19.8306 36.2 17.9277C36.2 16.0247 34.8 14.322 33 14.0216V11.9183H36.2V9.91516H48C48.6 9.91516 49 10.3158 49 10.9167C49 12.2188 49.8 13.3205 51 13.7211V22.635L40 42.6663V42.9667C40 46.8728 43.1 49.9777 47 49.9777H57C60.9 49.9777 64 46.8728 64 42.9667V42.6663L53.1 22.635ZM17 47.8744H7C4.6 47.8744 2.6 46.1717 2.1 43.8681H21.9C21.4 46.1717 19.4 47.8744 17 47.8744ZM21.3 41.865H2.7L12 24.9386L21.3 41.865ZM41.9 61.8963H22.1C22.6 59.4925 24.6 57.7898 27.1 57.7898H36.9C39.4 57.7898 41.4 59.5927 41.9 61.8963ZM36.1 54.8853V55.7867H28V54.8853L32 50.0778L36.1 54.8853ZM34 27.8431L34.1 46.372L32 47.3736L30 46.372V27.8431C30 26.7414 30.9 25.84 32 25.84C33.1 25.84 34 26.7414 34 27.8431ZM34.2 17.8275C34.2 18.9292 33.3 19.8306 32.2 19.8306H32C30.9 19.8306 30 18.9292 30 17.8275C30 16.7258 30.9 15.8244 32 15.8244H32.2C33.4 15.8244 34.2 16.7258 34.2 17.8275ZM34.2 9.81501H30V6.91048L32.1 3.70548L34.2 6.91048V9.81501ZM52.1 24.9386L61.4 41.865H42.8L52.1 24.9386ZM57.1 47.8744H47.1C44.7 47.8744 42.7 46.1717 42.2 43.8681H62C61.5 46.1717 59.5 47.8744 57.1 47.8744Z" fill="url(#paint0_linear_294_12106)" />
                </g>
                <defs>
                  <linearGradient id="paint0_linear_294_12106" x1="32" y1="0.0998535" x2="32" y2="63.8994" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#002A57" />
                    <stop offset="1" stopColor="#FFA500" />
                  </linearGradient>
                </defs>
              </svg>
              </div>
              <div className="font-primary text-[24px] font-bold leading-[33.6px] text-custom-blue">
                Racial Equity
              </div>
              <div className="font-secondary text-[15.88px] leading-[24px] text-custom-lightgray">
                We work to eliminate racial disparities and promote equal opportunities for all community members.
              </div>
              <div className="font-primary text-[14px] leading-[18px] text-left text-custom-orange" style={{ marginTop: "41px" }}>
                Donate
              </div>
            </div>
          </div>
          <div className="w-[380px] h-[339px] border border-neutral-100 rounded-[20px] flex flex-col p-[20px]">
            <div className="flex flex-col items-left gap-[8px]">
              <div style={{ marginBottom: "48px" }}>
              <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.1875 64.542H11.8912C12.1088 64.542 12.3175 64.4555 12.4713 64.3017C12.6251 64.1479 12.7116 63.9392 12.7116 63.7216V61.3921H14.1306C16.7923 61.3915 19.4012 62.1349 21.6628 63.5386C24.221 65.1257 27.0945 65.257 30.0598 65.257H37.9589C38.6236 65.2575 39.2749 65.0697 39.8373 64.7152C40.3996 64.3607 40.85 63.8541 41.1362 63.2541C41.4223 62.6541 41.5326 61.9853 41.4542 61.3252C41.3759 60.665 41.112 60.0407 40.6932 59.5244C41.2343 59.2715 41.7022 58.8854 42.0533 58.4023C42.4044 57.9192 42.6272 57.3549 42.7007 56.7622C42.7741 56.1695 42.696 55.5679 42.4735 55.0137C42.251 54.4594 41.8915 53.9708 41.4286 53.5934C41.831 53.258 42.1556 52.839 42.3797 52.3655C42.6039 51.8921 42.7223 51.3755 42.7268 50.8517C42.7313 50.3279 42.6217 49.8093 42.4056 49.3321C42.1895 48.8549 41.8722 48.4305 41.4755 48.0883C42.0166 47.6529 42.4093 47.0603 42.5992 46.3922C42.7892 45.7242 42.7671 45.0137 42.536 44.3587C42.305 43.7038 41.8763 43.1367 41.3092 42.7357C40.7421 42.3348 40.0646 42.1197 39.3701 42.1202H39.1439C41.5447 41.5323 43.0322 39.312 43.0322 36.1319V36.028C43.0322 35.8105 42.9458 35.6018 42.792 35.448C42.6381 35.2941 42.4295 35.2077 42.2119 35.2077H35.1641L34.2742 30.991C36.6697 30.9848 39.0587 31.2411 41.3984 31.7554L55.609 34.8948C55.6671 34.9077 55.7264 34.9142 55.7859 34.9142C55.9088 34.9142 56.0301 34.8866 56.1409 34.8334C56.2516 34.7802 56.349 34.7028 56.4259 34.607C56.5027 34.5111 56.5571 34.3992 56.5849 34.2795C56.6127 34.1598 56.6133 34.0354 56.5865 33.9155L54.7262 25.566C56.0867 25.0304 57.2112 24.0264 57.8971 22.7351C58.583 21.4437 58.7851 19.9499 58.4671 18.5227C58.1492 17.0955 57.3319 15.8288 56.1627 14.9508C54.9935 14.0728 53.5491 13.6412 52.0898 13.7339L50.2305 5.38403C50.2005 5.24939 50.137 5.1245 50.0459 5.0209C49.9548 4.9173 49.8391 4.83834 49.7094 4.79132C49.5798 4.7443 49.4403 4.73074 49.304 4.75189C49.1677 4.77305 49.0389 4.82823 48.9296 4.91235L37.3953 13.787C33.6024 16.6965 29.2217 18.7455 24.5574 19.7919C24.1116 19.8911 23.6897 20.0772 23.3158 20.3395C22.9419 20.6018 22.6234 20.9352 22.3783 21.3206C22.1333 21.706 21.9666 22.136 21.8877 22.5858C21.8089 23.0357 21.8194 23.4967 21.9188 23.9425L23.0744 29.13C23.2759 30.0298 23.826 30.813 24.6042 31.3077C25.3823 31.8024 26.325 31.9682 27.2252 31.7687C27.2609 31.7608 27.297 31.7542 27.3327 31.7464L28.1039 35.2083H23.4078C19.6391 35.2083 18.6993 38.0299 18.1944 39.5457C18.0819 39.8834 17.9293 40.3412 17.8274 40.474C16.5739 41.2523 15.4261 41.6308 14.3194 41.6308H12.7116V38.8916C12.7116 38.674 12.6251 38.4654 12.4713 38.3116C12.3175 38.1577 12.1088 38.0713 11.8912 38.0713H2.1875C1.96994 38.0713 1.76129 38.1577 1.60745 38.3116C1.45361 38.4654 1.36719 38.674 1.36719 38.8916V63.7216C1.36719 63.9392 1.45361 64.1479 1.60745 64.3017C1.76129 64.4555 1.96994 64.542 2.1875 64.542ZM41.3632 36.8485C41.0683 40.3498 38.6031 40.6364 37.8146 40.6364H36.3096L35.5102 36.8485H41.3632ZM54.8889 16.0641C55.5701 16.4972 56.1222 17.1058 56.487 17.8259C56.8518 18.546 57.016 19.3511 56.9622 20.1566C56.9085 20.9621 56.6388 21.7382 56.1815 22.4035C55.7242 23.0687 55.0962 23.5986 54.3635 23.9373L52.4531 15.3624C53.3158 15.3559 54.1619 15.5997 54.8889 16.0641ZM38.3957 15.0871L48.9094 6.99799L54.7055 33.0156L41.7528 30.1542C39.3187 29.6187 36.8337 29.3493 34.3414 29.3507C33.3043 29.3507 32.2688 29.3979 31.2349 29.4923L29.1534 20.152C32.4748 18.9459 35.5918 17.2378 38.3957 15.0871ZM24.6762 28.7733L23.5205 23.5858C23.4146 23.1102 23.5019 22.6121 23.7633 22.2009C24.0247 21.7897 24.4387 21.4992 24.9143 21.3932C25.8144 21.1927 26.7065 20.955 27.5904 20.6801L29.5947 29.6762C28.6788 29.8029 27.7701 29.9663 26.8688 30.1664C26.3934 30.2718 25.8955 30.1843 25.4845 29.9232C25.0735 29.662 24.7828 29.2485 24.6762 28.7733ZM32.6074 31.0371L34.9465 42.1208H31.3253L29.9307 35.864V35.8608L28.9447 31.4348C30.1572 31.2337 31.38 31.1009 32.6074 31.0371ZM14.3194 43.2711C15.7515 43.2711 17.1935 42.805 18.7273 41.846C19.2704 41.5065 19.493 40.8379 19.7509 40.064C20.2528 38.5569 20.8219 36.8486 23.4078 36.8486H28.4699L29.6445 42.1209H29.5761C29.2624 42.1211 28.9597 42.0054 28.7261 41.7959C28.4926 41.5864 28.3448 41.298 28.311 40.9861C28.2859 40.7712 28.1768 40.5748 28.0075 40.4399C27.8383 40.305 27.6226 40.2425 27.4074 40.266C27.1922 40.2894 26.9951 40.3969 26.8588 40.5651C26.7226 40.7333 26.6584 40.9485 26.6801 41.1639C26.757 41.878 27.0953 42.5384 27.63 43.018C28.1647 43.4976 28.8578 43.7624 29.5761 43.7615H39.3709C39.826 43.7615 40.2624 43.9423 40.5842 44.2641C40.9059 44.5859 41.0867 45.0223 41.0867 45.4773C41.0867 45.9324 40.9059 46.3688 40.5842 46.6906C40.2624 47.0124 39.826 47.1932 39.3709 47.1932H37.0357C36.9896 47.1934 36.9436 47.1976 36.8982 47.2055H35.3776C35.1601 47.2055 34.9514 47.2919 34.7976 47.4457C34.6437 47.5996 34.5573 47.8082 34.5573 48.0258C34.5573 48.2433 34.6437 48.452 34.7976 48.6058C34.9514 48.7597 35.1601 48.8461 35.3776 48.8461H39.1114C39.6352 48.8461 40.1376 49.0542 40.508 49.4246C40.8784 49.795 41.0864 50.2973 41.0864 50.8211C41.0864 51.345 40.8784 51.8473 40.508 52.2177C40.1376 52.5881 39.6352 52.7962 39.1114 52.7962H35.3776C35.1601 52.7962 34.9514 52.8826 34.7976 53.0364C34.6437 53.1903 34.5573 53.3989 34.5573 53.6165C34.5573 53.8341 34.6437 54.0427 34.7976 54.1965C34.9514 54.3504 35.1601 54.4368 35.3776 54.4368H39.1958C39.4454 54.4347 39.693 54.482 39.9242 54.5761C40.1555 54.6701 40.3658 54.8091 40.5431 54.9848C40.7203 55.1606 40.861 55.3697 40.9571 55.6002C41.0531 55.8306 41.1025 56.0778 41.1025 56.3274C41.1025 56.5771 41.0531 56.8242 40.9571 57.0547C40.861 57.2851 40.7203 57.4942 40.5431 57.67C40.3658 57.8458 40.1555 57.9847 39.9242 58.0788C39.693 58.1728 39.4454 58.2202 39.1958 58.218H33.6909C33.4734 58.218 33.2647 58.3045 33.1109 58.4583C32.957 58.6121 32.8706 58.8208 32.8706 59.0383C32.8706 59.2559 32.957 59.4646 33.1109 59.6184C33.2647 59.7722 33.4734 59.8587 33.6909 59.8587H37.9589C38.207 59.8565 38.453 59.9036 38.6829 59.9971C38.9127 60.0905 39.1217 60.2286 39.2979 60.4033C39.4741 60.578 39.6139 60.7858 39.7094 61.0149C39.8048 61.2439 39.854 61.4895 39.854 61.7377C39.854 61.9858 39.8048 62.2314 39.7094 62.4604C39.6139 62.6895 39.4741 62.8973 39.2979 63.072C39.1217 63.2467 38.9127 63.3848 38.6829 63.4782C38.453 63.5717 38.207 63.6188 37.9589 63.6166H30.0598C27.3409 63.6166 24.7189 63.5041 22.5277 62.1447C20.0064 60.58 17.0979 59.7513 14.1306 59.7522H12.7116V43.2711H14.3194ZM3.00781 39.7119H11.0709V62.9013H3.00781V39.7119Z" fill="url(#paint0_linear_294_12126)"/>
<path d="M59.512 26.5573C59.3395 26.6856 59.2243 26.8766 59.1912 27.089C59.1581 27.3014 59.2097 27.5184 59.3349 27.6931C59.4602 27.8679 59.649 27.9865 59.8608 28.0235C60.0726 28.0604 60.2904 28.0127 60.4674 27.8907C61.9083 26.8583 63.0139 25.4251 63.6465 23.7692C64.2791 22.1134 64.4109 20.3081 64.0255 18.5779C63.64 16.8478 62.7544 15.2692 61.4787 14.0385C60.203 12.8078 58.5935 11.9794 56.8507 11.6563C56.6367 11.6167 56.4158 11.6636 56.2365 11.7869C56.0572 11.9102 55.9342 12.0996 55.8946 12.3135C55.855 12.5274 55.9019 12.7484 56.0252 12.9277C56.1484 13.107 56.3379 13.23 56.5518 13.2696C57.9784 13.5339 59.2958 14.2119 60.34 15.2192C61.3843 16.2266 62.1092 17.5187 62.4247 18.9349C62.7402 20.3511 62.6323 21.8288 62.1144 23.1841C61.5965 24.5394 60.6915 25.7125 59.512 26.5574V26.5573Z" fill="url(#paint1_linear_294_12126)"/>
<path d="M57.7178 7.40434C57.5038 7.36473 57.2829 7.41172 57.1036 7.53498C56.9244 7.65825 56.8014 7.84768 56.7618 8.06162C56.7221 8.27555 56.7691 8.49646 56.8924 8.67575C57.0157 8.85503 57.2051 8.97801 57.419 9.01762C59.6758 9.43591 61.7598 10.5085 63.4116 12.1021C65.0634 13.6956 66.2103 15.7397 66.7093 17.98C67.2084 20.2203 67.0377 22.5579 66.2185 24.7019C65.3993 26.8459 63.9677 28.7017 62.1019 30.0384C61.925 30.1651 61.8057 30.3569 61.7703 30.5715C61.7348 30.7862 61.786 31.0061 61.9127 31.183C62.0394 31.3599 62.2312 31.4792 62.4458 31.5147C62.6605 31.5502 62.8804 31.4989 63.0573 31.3722C65.1848 29.8482 66.8171 27.7322 67.7512 25.2875C68.6853 22.8429 68.8799 20.1775 68.3109 17.6231C67.7418 15.0687 66.4342 12.7381 64.5507 10.9211C62.6672 9.10417 60.291 7.88119 57.7178 7.40434Z" fill="url(#paint2_linear_294_12126)"/>
<defs>
<linearGradient id="paint0_linear_294_12126" x1="29.9906" y1="4.74219" x2="29.9906" y2="65.257" gradientUnits="userSpaceOnUse">
<stop stop-color="#002A57"/>
<stop offset="1" stop-color="#FFA500"/>
</linearGradient>
<linearGradient id="paint1_linear_294_12126" x1="60.0613" y1="11.6426" x2="60.0613" y2="28.0357" gradientUnits="userSpaceOnUse">
<stop stop-color="#002A57"/>
<stop offset="1" stop-color="#FFA500"/>
</linearGradient>
<linearGradient id="paint2_linear_294_12126" x1="62.6891" y1="7.39062" x2="62.6891" y2="31.5257" gradientUnits="userSpaceOnUse">
<stop stop-color="#002A57"/>
<stop offset="1" stop-color="#FFA500"/>
</linearGradient>
</defs>
</svg>

              </div>
              <div className="font-primary text-[24px] font-bold leading-[33.6px] text-custom-blue">
                Civic Engagement
              </div>
              <div className="font-secondary text-[15.88px] leading-[24px] text-custom-lightgray">
                We foster civic participation to ensure every voice is heard and valued.
              </div>
              <div className="font-primary text-[14px] leading-[18px] text-left text-custom-orange" style={{ marginTop: "65px" }}>
                Donate
              </div>
            </div>
          </div>
          <div className="w-[380px] h-[339px] border border-neutral-100 rounded-[20px] flex flex-col p-[20px]">
            <div className="flex flex-col items-left gap-[8px]">
              <div style={{ marginBottom: "48px" }}>
              <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M69.7953 33.152L62.126 12.5036C61.8228 11.687 61.2177 11.0368 60.4224 10.6721C59.6267 10.3082 58.7396 10.274 57.923 10.5767L52.7898 12.483C51.0999 13.1108 50.2356 14.9966 50.8631 16.6864L50.9464 16.9106C49.7319 17.3716 48.3765 16.8681 46.3047 16.0003C43.2111 14.7052 39.0154 12.9661 33.6889 16.2976C29.3659 13.6068 25.9738 14.2706 22.9696 14.8687C21.4437 15.172 19.9903 15.4574 18.4892 15.3021C18.447 14.9077 18.3388 14.519 18.1522 14.1544C17.7531 13.3753 17.0769 12.7989 16.2484 12.5316L11.0374 10.8507C10.2084 10.5834 9.32291 10.6561 8.54416 11.0543C7.76541 11.4533 7.18901 12.1296 6.922 12.9581L0.158109 33.9209C-0.395192 35.6366 0.550355 37.4825 2.26618 38.0358L7.47707 39.7174C7.80588 39.8236 8.14344 39.8762 8.47963 39.8762C8.99137 39.8762 9.5001 39.7543 9.97001 39.5138C10.2603 39.365 10.5111 39.1669 10.7396 38.9476C10.7717 39.1062 10.8148 39.263 10.8536 39.4205L9.54905 41.8595C8.98959 42.906 8.88118 44.1751 9.25223 45.3407C9.61344 46.4758 10.3752 47.3822 11.3744 47.8814C12.2451 48.3473 13.2044 48.4929 14.1152 48.3587C13.855 49.2215 13.8599 50.1677 14.142 51.0545C14.5032 52.1895 15.265 53.0962 16.2641 53.5954C17.3092 54.1543 18.5122 54.2709 19.6522 53.9261C20.1076 53.7879 20.5307 53.5828 20.91 53.3192C21.2758 54.4366 22.0317 55.3284 23.0195 55.822C24.0643 56.3809 25.2673 56.4975 26.4073 56.1527C26.6604 56.0758 26.9037 55.9784 27.1346 55.8618C27.4774 57.2379 28.4559 58.4634 29.6756 59.1158C30.2581 59.4271 30.9442 59.6278 31.6563 59.6278C32.9505 59.6278 34.3306 58.9646 35.3289 57.0985L35.5236 56.7343C35.5994 56.774 35.6749 56.8138 35.7442 56.85L36.2648 57.1215C36.9025 57.4498 37.5258 57.5944 38.1118 57.5944C39.5737 57.5944 40.8017 56.6934 41.4295 55.4969C41.8618 54.6736 42.014 53.6947 41.8043 52.7445C42.3317 52.7718 42.8651 52.709 43.3864 52.5511C44.5571 52.1964 45.5178 51.4104 46.0915 50.3378C46.555 49.4713 46.7227 48.4987 46.583 47.5394C47.5622 47.9459 48.6451 47.9988 49.6779 47.686C50.8588 47.3282 51.8278 46.535 52.4064 45.4533C52.8793 44.5685 53.0472 43.5743 52.897 42.5958C54.4929 43.232 56.0327 42.941 57.1019 41.7696C58.1858 40.5825 58.5503 38.7637 58.1449 37.1407C58.2287 37.1107 58.3136 37.0802 58.408 37.0463L58.423 37.0409L58.5324 37.3352C59.0214 38.6509 60.2731 39.4659 61.6007 39.4659C61.9782 39.4659 62.3616 39.4003 62.7354 39.2615L67.8683 37.3553C69.5585 36.7274 70.4228 34.8421 69.7953 33.152ZM9.79213 37.0289C9.67975 37.3769 9.4368 37.6614 9.10758 37.8298C8.77782 37.9982 8.40526 38.0293 8.05785 37.9173L2.84668 36.2354C2.12371 36.0023 1.72518 35.2245 1.95828 34.5015L8.72244 13.5389C8.83455 13.1912 9.0775 12.9067 9.40659 12.7382C9.60551 12.6364 9.82071 12.5846 10.0366 12.5846C10.1777 12.5846 10.3186 12.6064 10.456 12.6507C10.4563 12.6507 10.4563 12.6507 10.4563 12.651L15.6675 14.3322C16.0152 14.4443 16.2997 14.6873 16.4681 15.0164C16.6365 15.3456 16.6676 15.7182 16.5556 16.0661L11.1556 32.8029C11.132 32.8486 11.1091 32.8954 11.0929 32.9459C11.0454 33.0922 11.0088 33.2403 10.9671 33.3875L9.79213 37.0289ZM12.2435 46.2012C11.6819 45.9207 11.2597 45.4114 11.055 44.7672C10.8379 44.0851 10.8971 43.3505 11.2173 42.7518L12.6911 39.9963C12.6914 39.996 12.6918 39.9957 12.6919 39.9953L13.3959 38.679C14.0517 37.4534 15.5714 36.9798 16.8046 37.6022C17.6135 38.1678 18.8269 39.3705 17.9063 41.0915L17.4046 42.0294L15.7259 45.1681C15.0598 46.4084 13.5091 46.8788 12.2435 46.2012ZM20.6177 50.8783C20.2975 51.4775 19.7595 51.9169 19.103 52.1158C18.4468 52.3148 17.7552 52.2476 17.1332 51.9154C16.5716 51.6349 16.1494 51.1253 15.9447 50.4811C15.7276 49.7994 15.7871 49.0647 16.1073 48.4661L17.3941 46.0607L19.0729 42.922C19.3931 42.3231 19.9311 41.8838 20.5872 41.6849C21.2437 41.4854 21.9347 41.5528 22.5342 41.8733C23.1331 42.1935 23.5724 42.7315 23.7714 43.388C23.9703 44.0441 23.9031 44.7357 23.5825 45.335L23.1111 46.2168C23.1109 46.2178 23.1102 46.2186 23.1096 46.2196L21.1943 49.8004C21.1943 49.8006 21.1943 49.8006 21.1941 49.8009L20.6177 50.8783ZM25.8584 54.3423C25.2018 54.5412 24.5109 54.4741 23.8887 54.1419C23.327 53.8613 22.9051 53.352 22.7002 52.708C22.4837 52.0268 22.5422 51.2937 22.8612 50.6955L22.8627 50.6927L24.778 47.1119C24.7781 47.1115 24.7783 47.1111 24.7784 47.1107L24.7795 47.1089C25.1001 46.5112 25.6374 46.0731 26.2926 45.8745C26.9484 45.6746 27.6401 45.7421 28.2392 46.0629C29.4825 46.728 29.9531 48.2809 29.2882 49.5242L28.3306 51.3148L27.4818 52.9018C27.4815 52.9024 27.4811 52.9031 27.4808 52.9036L27.3731 53.105C27.0529 53.7037 26.5146 54.1434 25.8584 54.3423ZM30.5678 57.4476C29.3277 56.7844 28.4404 55.1206 29.1501 53.7938L29.999 52.2067L30 52.2046C30.331 51.5875 30.9194 51.0918 31.615 50.8448C32.3094 50.5978 33.0066 50.6308 33.5786 50.9368C34.8251 51.6031 35.0262 52.1862 35.0686 52.5669C35.1332 53.1423 34.8896 53.9075 34.2797 55.0478C34.2793 55.0487 34.279 55.0497 34.2786 55.0505L33.6605 56.2062C32.6135 58.1654 31.2738 57.8248 30.5678 57.4476ZM39.7545 54.6182C39.3083 55.4695 38.3242 56.054 37.1307 55.44L36.6239 55.1755C36.5401 55.1312 36.4619 55.0901 36.3893 55.0523C36.7723 54.2002 37.0515 53.2744 36.9487 52.3565C36.8328 51.3214 36.2584 50.4581 35.2164 49.7301L38.9418 51.7307C40.1868 52.6049 40.1825 53.8027 39.7545 54.6182ZM55.7046 40.4943C55.0955 41.1622 54.2595 41.2188 53.2191 40.6618L50.5211 39.2189C50.5191 39.2179 50.5174 39.217 50.5154 39.2161C50.4878 39.2014 50.459 39.1929 50.4307 39.1811L41.7309 34.4587C41.2727 34.209 40.6978 34.3796 40.4484 34.839C40.1993 35.2981 40.3693 35.872 40.8287 36.1214L49.7125 40.9437C50.3005 41.2885 50.7372 41.8309 50.9382 42.4932C51.1494 43.1903 51.0783 43.9246 50.7378 44.5612C50.3975 45.1976 49.826 45.6645 49.1288 45.8757C48.4305 46.0867 47.6967 46.0159 47.0608 45.6756L44.3784 44.2408C44.3318 44.2028 44.2815 44.1681 44.2265 44.1387L37.7529 40.6774C37.2916 40.4305 36.7189 40.6053 36.4729 41.0657C36.2266 41.5263 36.4002 42.0994 36.8612 42.3456L43.1721 45.72C43.2189 45.7583 43.2696 45.7931 43.325 45.8227C43.9523 46.158 44.4123 46.7209 44.6204 47.4082C44.8285 48.0952 44.7584 48.8187 44.423 49.4457C44.0876 50.073 43.5245 50.5326 42.8375 50.7411C42.1509 50.9489 41.4269 50.8791 40.7999 50.5437L39.4306 49.8114C39.3617 49.7747 39.29 49.7502 39.2177 49.7317L33.6907 46.764C33.2304 46.5151 32.6567 46.6892 32.4101 47.1498C32.1627 47.6099 32.3355 48.1835 32.7959 48.4304L33.9574 49.0541C33.1688 48.7635 32.3051 48.7085 31.4407 48.9237C31.6849 47.1328 30.8156 45.2952 29.1313 44.3942C28.0963 43.8407 26.9054 43.7202 25.775 44.0543C25.7669 43.6479 25.7029 43.2396 25.5816 42.8391C25.2362 41.6988 24.4704 40.7634 23.4259 40.2048C22.3759 39.6437 21.1997 39.547 20.1352 39.8438C20.117 38.2368 19.0969 36.9004 17.8822 36.0475C17.8406 36.0156 17.7963 35.9868 17.7492 35.9617C15.9356 34.9921 13.7437 35.4111 12.4003 36.846C12.3786 35.8623 12.5131 34.8745 12.7864 33.9078L18.1853 17.1743C20.0104 17.3856 21.699 17.0507 23.3381 16.724C26.0632 16.182 28.6513 15.6669 31.9955 17.4898C31.267 18.0699 30.5341 18.7318 29.8056 19.4678C29.2289 20.051 28.6358 20.6333 28.0572 21.2014C25.9479 23.2731 24.1263 25.0623 23.6054 26.3322C23.4795 26.6391 23.5235 26.9895 23.7214 27.2556C27.4864 32.319 32.0491 30.6008 35.7139 29.2208C38.4614 28.1858 40.8343 27.2917 42.7245 28.7875C42.7602 28.8158 42.7978 28.8414 42.8372 28.8642C43.7399 29.3873 44.9834 30.0013 46.4232 30.7124C49.9042 32.4317 54.6717 34.7865 55.9037 36.659C56.7315 37.9164 56.4689 39.6571 55.7046 40.4943ZM57.3372 35.4212C55.6857 33.1816 51.0306 30.8779 47.2614 29.0166C45.8826 28.3355 44.6875 27.7456 43.8419 27.2599C41.1267 25.1615 38.0367 26.3248 35.0475 27.4505C31.5046 28.7841 28.4239 29.9437 25.6098 26.5958C26.2708 25.608 27.8493 24.0579 29.383 22.5516C29.968 21.977 30.5672 21.3883 31.1505 20.7989C32.1611 19.7782 33.1724 18.9196 34.1584 18.241C38.9236 14.9641 42.4562 16.4406 45.5738 17.7453C47.0314 18.3556 48.5194 18.9785 49.9911 18.9785C50.5317 18.9785 51.0694 18.8798 51.6035 18.6803L57.7641 35.2676C57.6206 35.3192 57.4753 35.3716 57.3372 35.4212ZM67.21 35.5817L62.0771 37.488C61.3627 37.7516 60.5697 37.3882 60.3056 36.6763L52.6366 16.0273C52.5095 15.6849 52.5243 15.3114 52.6782 14.9751C52.8324 14.6389 53.1059 14.3836 53.4483 14.2564L58.5813 12.3501C58.7355 12.2928 58.896 12.2642 59.0564 12.2642C59.2529 12.2642 59.4491 12.307 59.634 12.3916C59.97 12.5456 60.2252 12.8193 60.3524 13.1621L68.0216 33.8106C68.2862 34.5229 67.9219 35.3172 67.21 35.5817Z" fill="url(#paint0_linear_294_12131)" />
                <defs>
                  <linearGradient id="paint0_linear_294_12131" x1="35" y1="10.3721" x2="35" y2="59.6278" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#002A57" />
                    <stop offset="1" stopColor="#FFA500" />
                  </linearGradient>
                </defs>
              </svg>
              </div>
              <div className="font-primary text-[24px] font-bold leading-[33.6px] text-custom-blue">
                Fair Economy
              </div>
              <div className="font-secondary text-[15.88px] leading-[24px] text-custom-lightgray">
                We advocate for fair policies and practices to create sustainable communities.
              </div>
              <div className="font-primary text-[14px] leading-[18px] text-left text-custom-orange" style={{ marginTop: "41px" }}>
                Donate
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}

      {/* <div
        style={{
          width: "100%",
          height: "474px",
          margin: "0 auto",
          gap: "0px",
          opacity: "1",
          position: "relative",
          background: "rgba(255, 242, 219, 1)",
        }}
      >
        <div
          style={{
            width: "126px",
            height: "22px",
            position: "absolute",
            top: "32px",
            left: "50%",
            transform: "translateX(-50%)",
            fontFamily: "Manrope",
            fontSize: "16px",
            fontWeight: "700",
            lineHeight: "21.86px",
            letterSpacing: "2px",
            textAlign: "center",
            color: "rgba(255, 165, 0, 1)",
            whiteSpace: "nowrap",
          }}
        >
          OUR HISTORY
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              left: "120px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
            onClick={handlePrev}
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="36" height="36" rx="18" fill="#002A57" />
              <g clipPath="url(#clip0_704_3422)">
                <g clipPath="url(#clip1_704_3422)">
                  <path
                    d="M15.9744 12.9419L10.916 18.0002L15.9744 23.0586"
                    stroke="white"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M25.0836 18H11.0586"
                    stroke="white"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_704_3422">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
                <clipPath id="clip1_704_3422">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div
            style={{
              width: "472px",
              height: "332px",
              borderRadius: "20px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <img
              src={images[currentIndex]}
              alt="Our History"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                transition: "all 0.5s ease-in-out",
                opacity: isTransitioning ? 0 : 1,
              }}
            />
          </div>
          <div
            style={{
              width: "514px",
              height: "auto",
              marginLeft: "47px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              transition: "all 0.5s ease-in-out",
              opacity: isTransitioning ? 0 : 1,
              transform: isTransitioning ? "translateY(20px)" : "translateY(0)",
            }}
          >
            <div
              style={{
                width: "57px",
                height: "29px",
                padding: "0px 7px 0px 10px",
                borderRadius: "200px",
                background: getBackgroundColor(content[currentIndex].year),
                display: "flex",
                alignItems: "center",
                marginBottom: "24px",
              }}
            >
              <span
                style={{
                  fontFamily: "Manrope",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "28.8px",
                  textAlign: "center",
                  color: "rgba(67, 62, 63, 1)",
                }}
              >
                {content[currentIndex].year}
              </span>
            </div>
            <div
              style={{
                width: "514px",
                fontFamily: "Manrope",
                fontSize: "32px",
                fontWeight: "700",
                lineHeight: "38.4px",
                textAlign: "left",
                color: "rgba(0, 42, 87, 1)",
                marginBottom:
                  content[currentIndex].description.length < 100
                    ? "16px"
                    : "24px",
                transition: "margin-bottom 0.3s ease-in-out",
              }}
            >
              {content[currentIndex].title}
            </div>
            <div
              style={{
                width: "482px",
                fontFamily: "Open Sans",
                fontSize: "18px",
                fontWeight: "400",
                lineHeight: "28.8px",
                textAlign: "left",
                color: "rgba(67, 62, 63, 1)",
              }}
            >
              {content[currentIndex].description}
            </div>
          </div>
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "120px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
            onClick={handleNext}
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="36" height="36" rx="18" fill="#002A57" />
              <g clipPath="url(#clip0_704_3428)">
                <g clipPath="url(#clip1_704_3428)">
                  <path
                    d="M20.0234 12.9419L25.0817 18.0002L20.0234 23.0586"
                    stroke="white"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.916 18H24.941"
                    stroke="white"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_704_3428">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
                <clipPath id="clip1_704_3428">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div> */}

      <div className="w-full h-auto px-4 md:h-[474px] relative bg-[rgba(255,242,219,1)]">
        {/* 'OUR HISTORY' Text */}
        <div className="w-full md:w-[126px] h-[22px] mt-8 md:mt-0 md:absolute md:top-[32px] md:left-1/2 md:transform md:-translate-x-1/2 font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-center text-custom-orange whitespace-nowrap">
          OUR HISTORY
        </div>
        {/* Main Content */}
        <div className="flex flex-col md:flex-row w-full h-full justify-center items-center relative">
          {/* Left Arrow */}

          <div
            className="cursor-pointer absolute left-4 md:left-[120px] top-1/2 transform -translate-y-1/2 z-20"
            onClick={handlePrev}
          >
            <svg
              className="w-8 h-8 md:w-9 md:h-9"
              viewBox="0 0 36 36"
              fill="none"
            >
              {/* SVG content for left arrow */}
              <rect width="36" height="36" rx="18" fill="#002A57" />
              <path
                d="M15.9744 12.9419L10.916 18.0002L15.9744 23.0586"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25.0836 18H11.0586"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          {/* Image */}
          <div className="w-full md:w-[472px] h-[332px] rounded-lg overflow-hidden relative mt-4 md:mt-0">
            <img
              src={images[currentIndex]}
              alt="Our History"
              className={`w-full h-full object-cover transition-all duration-500 ease-in-out ${
                isTransitioning ? "opacity-0" : "opacity-100"
              }`}
            />
          </div>

          <div
            className={`w-full md:w-[514px] h-auto mt-4 md:mt-0 md:ml-[47px] flex flex-col justify-center transition-all duration-500 ease-in-out ${
              isTransitioning
                ? "opacity-0 translate-y-[20px]"
                : "opacity-100 translate-y-0"
            }`}
          >
            <div
              className="w-[57px] h-[29px] pl-[10px] pr-[7px] rounded-full flex items-center mb-[24px] mx-auto md:mx-0"
              style={{
                background: getBackgroundColor(content[currentIndex].year),
              }}
            >
              <span className="font-primary text-[16px] font-semibold leading-[28.8px] text-center text-custom-lightgray">
                {content[currentIndex].year}
              </span>
            </div>
            <div
              className="w-full md:w-[514px] font-primary text-[24px] md:text-[32px] font-bold leading-[28.8px] md:leading-[38.4px] text-center md:text-left text-custom-blue transition-all duration-300 ease-in-out"
              style={{
                marginBottom:
                  content[currentIndex].description.length < 100
                    ? "16px"
                    : "24px",
              }}
            >
              {content[currentIndex].title}
            </div>
            <div className="w-full md:w-[482px] font-secondary text-[16px] md:text-[18px] font-normal leading-[24px] md:leading-[28.8px] text-center md:text-left text-custom-lightgray">
              {content[currentIndex].description}
            </div>
          </div>

          <div
            className="cursor-pointer absolute right-4 md:right-[120px] top-1/2 transform -translate-y-1/2"
            onClick={handleNext}
          >
            <svg
              className="w-8 h-8 md:w-9 md:h-9"
              viewBox="0 0 36 36"
              fill="none"
            >
              <rect width="36" height="36" rx="18" fill="#002A57" />
              <path
                d="M20.0234 12.9419L25.0817 18.0002L20.0234 23.0586"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.916 18H24.941"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* <div className="relative w-full max-w-[1440px] h-auto px-[120px] py-[50px] mx-auto box-border">
        <div className="w-full max-w-[1200px] h-auto mx-auto">
          <div className="flex flex-col items-start ">
            <div className="flex items-center gap-[10px]">
              <div
                className="w-[72px] h-0 border-t-2"
                style={{
                  borderColor: "rgba(255, 165, 0, 1)",
                  marginRight: "10px",
                }}
              ></div>
              <div
                className="w-[115px] h-[22px] font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-custom-orange"
                style={{ whiteSpace: "nowrap" }}
              >
                OUR IMPACT
              </div>
            </div>
            <div
              className="mt-[10px] w-[534px] h-[38px] font-primary text-[32px] font-bold leading-[38.4px] text-custom-blue"
              style={{
                whiteSpace: "nowrap",
                marginTop: "24px",
                marginBottom: "32px",
              }}
            >
              How do we help?
            </div>
          </div>
          <div className="flex justify-center gap-[30px] ">
            <div
              className="w-[380px] h-[339px] rounded-[20px] flex flex-col p-[20px]"
              style={{ border: "1px solid rgba(227, 227, 227, 1)" }}
            >
              {" "}
              <div className="flex flex-col items-left gap-[8px]">
                <div style={{ marginBottom: "50.9px" }}>
                 
                  <svg
                    width="64"
                    height="65"
                    viewBox="0 0 64 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_294_12106"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="64"
                      height="65"
                    >
                      <path d="M0 0H64V64.1H0V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_294_12106)">
                      <path
                        d="M53.1 22.635V13.7211C54.3 13.3205 55.1 12.2188 55.1 10.9167V9.91516H53.1V10.9167C53.1 11.5177 52.7 11.9183 52.1 11.9183C51.5 11.9183 51.1 11.5177 51.1 10.9167C51.1 9.21407 49.8 7.91204 48.1 7.91204H36.2V6.30954L32.1 0.0998535L28 6.30954V7.81188H16C14.3 7.81188 13 9.11391 13 10.8166C13 11.4175 12.6 11.8181 12 11.8181C11.4 11.8181 11 11.4175 11 10.8166V9.81501H9V10.8166C9 12.1186 9.8 13.2203 11 13.6209V22.5348L0 42.5661V42.8666C0 46.7727 3.1 49.8775 7 49.8775H17C20.9 49.8775 24 46.7727 24 42.8666V42.5661L13 22.5348V13.6209C14.2 13.2203 15 12.1186 15 10.8166C15 10.2156 15.4 9.81501 16 9.81501H28.1V11.8181H31V14.0216C29.3 14.5224 28.1 16.0247 28.1 17.8275C28.1 19.6303 29.3 21.2328 31 21.6334V24.0372C29.3 24.538 28 26.0403 28 27.8431V47.5739L30.4 48.7758L26 54.1842V55.8869C22.6 56.3877 20 59.3923 20 62.8978V63.8994H44V62.8978C44 59.3923 41.4 56.4878 38.1 55.8869V54.0841L33.5 48.7758L36.1 47.5739L36 27.8431C36 25.9402 34.7 24.4378 33 24.0372V21.8338C34.8 21.5333 36.2 19.8306 36.2 17.9277C36.2 16.0247 34.8 14.322 33 14.0216V11.9183H36.2V9.91516H48C48.6 9.91516 49 10.3158 49 10.9167C49 12.2188 49.8 13.3205 51 13.7211V22.635L40 42.6663V42.9667C40 46.8728 43.1 49.9777 47 49.9777H57C60.9 49.9777 64 46.8728 64 42.9667V42.6663L53.1 22.635ZM17 47.8744H7C4.6 47.8744 2.6 46.1717 2.1 43.8681H21.9C21.4 46.1717 19.4 47.8744 17 47.8744ZM21.3 41.865H2.7L12 24.9386L21.3 41.865ZM41.9 61.8963H22.1C22.6 59.4925 24.6 57.7898 27.1 57.7898H36.9C39.4 57.7898 41.4 59.5927 41.9 61.8963ZM36.1 54.8853V55.7867H28V54.8853L32 50.0778L36.1 54.8853ZM34 27.8431L34.1 46.372L32 47.3736L30 46.372V27.8431C30 26.7414 30.9 25.84 32 25.84C33.1 25.84 34 26.7414 34 27.8431ZM34.2 17.8275C34.2 18.9292 33.3 19.8306 32.2 19.8306H32C30.9 19.8306 30 18.9292 30 17.8275C30 16.7258 30.9 15.8244 32 15.8244H32.2C33.4 15.8244 34.2 16.7258 34.2 17.8275ZM34.2 9.81501H30V6.91048L32.1 3.70548L34.2 6.91048V9.81501ZM52.1 24.9386L61.4 41.865H42.8L52.1 24.9386ZM57.1 47.8744H47.1C44.7 47.8744 42.7 46.1717 42.2 43.8681H62C61.5 46.1717 59.5 47.8744 57.1 47.8744Z"
                        fill="url(#paint0_linear_294_12106)"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_294_12106"
                        x1="32"
                        y1="0.0998535"
                        x2="32"
                        y2="63.8994"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#002A57" />
                        <stop offset="1" stopColor="#FFA500" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="font-primary text-[24px] font-bold leading-[33.6px] text-custom-blue">
                  Racial Equity
                </div>
                <div className="font-secondary text-[15.88px] leading-[24px] text-custom-lightgray">
                  We work to eliminate racial disparities and promote equal
                  opportunities for all community members.
                </div>
              </div>
              <div
                className="font-primary text-[14px] leading-[18px] text-left text-custom-orange mt-auto flex items-center cursor-pointer"
                onClick={() => (window.location.href = "/donate")}
              >
                Donate
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35731 16.1874C8.22969 16.4265 8.29933 16.7311 8.52942 16.8943C8.77868 17.071 9.12233 17.0151 9.29649 16.7695L14.8426 8.94793L15.6947 13.7986L15.7124 13.8712C15.7945 14.1297 16.0578 14.2965 16.3326 14.2527C16.6319 14.2046 16.8323 13.9232 16.7797 13.6247L15.6972 7.46322L15.6798 7.39143C15.6431 7.27488 15.5683 7.17479 15.4705 7.10541C15.412 7.064 15.3457 7.03386 15.2743 7.01713C15.0563 6.96598 14.8313 7.04981 14.7034 7.23017L8.39335 16.1291L8.35731 16.1874ZM8.44057 8.65675C8.49475 8.9555 8.78074 9.15829 9.08023 9.10853L12.4847 8.54748L12.5576 8.53044C12.8162 8.45109 12.9791 8.19162 12.9294 7.91777C12.9024 7.76839 12.8181 7.64354 12.7031 7.562C12.5869 7.4796 12.4406 7.44094 12.2898 7.46599L8.88569 8.02644L8.813 8.0436C8.55476 8.12335 8.39146 8.38329 8.44057 8.65675Z"
                    fill="#FFA500"
                  />
                </svg>
              </div>
            </div>
            <div
              className="w-[380px] h-[339px] rounded-[20px] flex flex-col p-[20px]"
              style={{ border: "1px solid rgba(227, 227, 227, 1)" }}
            >
              {" "}
              <div className="flex flex-col items-left gap-[8px]">
                <div style={{ marginBottom: "48px" }}>
                 
                  <svg
                    width="70"
                    height="70"
                    viewBox="0 0 70 70"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.1875 64.542H11.8912C12.1088 64.542 12.3175 64.4555 12.4713 64.3017C12.6251 64.1479 12.7116 63.9392 12.7116 63.7216V61.3921H14.1306C16.7923 61.3915 19.4012 62.1349 21.6628 63.5386C24.221 65.1257 27.0945 65.257 30.0598 65.257H37.9589C38.6236 65.2575 39.2749 65.0697 39.8373 64.7152C40.3996 64.3607 40.85 63.8541 41.1362 63.2541C41.4223 62.6541 41.5326 61.9853 41.4542 61.3252C41.3759 60.665 41.112 60.0407 40.6932 59.5244C41.2343 59.2715 41.7022 58.8854 42.0533 58.4023C42.4044 57.9192 42.6272 57.3549 42.7007 56.7622C42.7741 56.1695 42.696 55.5679 42.4735 55.0137C42.251 54.4594 41.8915 53.9708 41.4286 53.5934C41.831 53.258 42.1556 52.839 42.3797 52.3655C42.6039 51.8921 42.7223 51.3755 42.7268 50.8517C42.7313 50.3279 42.6217 49.8093 42.4056 49.3321C42.1895 48.8549 41.8722 48.4305 41.4755 48.0883C42.0166 47.6529 42.4093 47.0603 42.5992 46.3922C42.7892 45.7242 42.7671 45.0137 42.536 44.3587C42.305 43.7038 41.8763 43.1367 41.3092 42.7357C40.7421 42.3348 40.0646 42.1197 39.3701 42.1202H39.1439C41.5447 41.5323 43.0322 39.312 43.0322 36.1319V36.028C43.0322 35.8105 42.9458 35.6018 42.792 35.448C42.6381 35.2941 42.4295 35.2077 42.2119 35.2077H35.1641L34.2742 30.991C36.6697 30.9848 39.0587 31.2411 41.3984 31.7554L55.609 34.8948C55.6671 34.9077 55.7264 34.9142 55.7859 34.9142C55.9088 34.9142 56.0301 34.8866 56.1409 34.8334C56.2516 34.7802 56.349 34.7028 56.4259 34.607C56.5027 34.5111 56.5571 34.3992 56.5849 34.2795C56.6127 34.1598 56.6133 34.0354 56.5865 33.9155L54.7262 25.566C56.0867 25.0304 57.2112 24.0264 57.8971 22.7351C58.583 21.4437 58.7851 19.9499 58.4671 18.5227C58.1492 17.0955 57.3319 15.8288 56.1627 14.9508C54.9935 14.0728 53.5491 13.6412 52.0898 13.7339L50.2305 5.38403C50.2005 5.24939 50.137 5.1245 50.0459 5.0209C49.9548 4.9173 49.8391 4.83834 49.7094 4.79132C49.5798 4.7443 49.4403 4.73074 49.304 4.75189C49.1677 4.77305 49.0389 4.82823 48.9296 4.91235L37.3953 13.787C33.6024 16.6965 29.2217 18.7455 24.5574 19.7919C24.1116 19.8911 23.6897 20.0772 23.3158 20.3395C22.9419 20.6018 22.6234 20.9352 22.3783 21.3206C22.1333 21.706 21.9666 22.136 21.8877 22.5858C21.8089 23.0357 21.8194 23.4967 21.9188 23.9425L23.0744 29.13C23.2759 30.0298 23.826 30.813 24.6042 31.3077C25.3823 31.8024 26.325 31.9682 27.2252 31.7687C27.2609 31.7608 27.297 31.7542 27.3327 31.7464L28.1039 35.2083H23.4078C19.6391 35.2083 18.6993 38.0299 18.1944 39.5457C18.0819 39.8834 17.9293 40.3412 17.8274 40.474C16.5739 41.2523 15.4261 41.6308 14.3194 41.6308H12.7116V38.8916C12.7116 38.674 12.6251 38.4654 12.4713 38.3116C12.3175 38.1577 12.1088 38.0713 11.8912 38.0713H2.1875C1.96994 38.0713 1.76129 38.1577 1.60745 38.3116C1.45361 38.4654 1.36719 38.674 1.36719 38.8916V63.7216C1.36719 63.9392 1.45361 64.1479 1.60745 64.3017C1.76129 64.4555 1.96994 64.542 2.1875 64.542ZM41.3632 36.8485C41.0683 40.3498 38.6031 40.6364 37.8146 40.6364H36.3096L35.5102 36.8485H41.3632ZM54.8889 16.0641C55.5701 16.4972 56.1222 17.1058 56.487 17.8259C56.8518 18.546 57.016 19.3511 56.9622 20.1566C56.9085 20.9621 56.6388 21.7382 56.1815 22.4035C55.7242 23.0687 55.0962 23.5986 54.3635 23.9373L52.4531 15.3624C53.3158 15.3559 54.1619 15.5997 54.8889 16.0641ZM38.3957 15.0871L48.9094 6.99799L54.7055 33.0156L41.7528 30.1542C39.3187 29.6187 36.8337 29.3493 34.3414 29.3507C33.3043 29.3507 32.2688 29.3979 31.2349 29.4923L29.1534 20.152C32.4748 18.9459 35.5918 17.2378 38.3957 15.0871ZM24.6762 28.7733L23.5205 23.5858C23.4146 23.1102 23.5019 22.6121 23.7633 22.2009C24.0247 21.7897 24.4387 21.4992 24.9143 21.3932C25.8144 21.1927 26.7065 20.955 27.5904 20.6801L29.5947 29.6762C28.6788 29.8029 27.7701 29.9663 26.8688 30.1664C26.3934 30.2718 25.8955 30.1843 25.4845 29.9232C25.0735 29.662 24.7828 29.2485 24.6762 28.7733ZM32.6074 31.0371L34.9465 42.1208H31.3253L29.9307 35.864V35.8608L28.9447 31.4348C30.1572 31.2337 31.38 31.1009 32.6074 31.0371ZM14.3194 43.2711C15.7515 43.2711 17.1935 42.805 18.7273 41.846C19.2704 41.5065 19.493 40.8379 19.7509 40.064C20.2528 38.5569 20.8219 36.8486 23.4078 36.8486H28.4699L29.6445 42.1209H29.5761C29.2624 42.1211 28.9597 42.0054 28.7261 41.7959C28.4926 41.5864 28.3448 41.298 28.311 40.9861C28.2859 40.7712 28.1768 40.5748 28.0075 40.4399C27.8383 40.305 27.6226 40.2425 27.4074 40.266C27.1922 40.2894 26.9951 40.3969 26.8588 40.5651C26.7226 40.7333 26.6584 40.9485 26.6801 41.1639C26.757 41.878 27.0953 42.5384 27.63 43.018C28.1647 43.4976 28.8578 43.7624 29.5761 43.7615H39.3709C39.826 43.7615 40.2624 43.9423 40.5842 44.2641C40.9059 44.5859 41.0867 45.0223 41.0867 45.4773C41.0867 45.9324 40.9059 46.3688 40.5842 46.6906C40.2624 47.0124 39.826 47.1932 39.3709 47.1932H37.0357C36.9896 47.1934 36.9436 47.1976 36.8982 47.2055H35.3776C35.1601 47.2055 34.9514 47.2919 34.7976 47.4457C34.6437 47.5996 34.5573 47.8082 34.5573 48.0258C34.5573 48.2433 34.6437 48.452 34.7976 48.6058C34.9514 48.7597 35.1601 48.8461 35.3776 48.8461H39.1114C39.6352 48.8461 40.1376 49.0542 40.508 49.4246C40.8784 49.795 41.0864 50.2973 41.0864 50.8211C41.0864 51.345 40.8784 51.8473 40.508 52.2177C40.1376 52.5881 39.6352 52.7962 39.1114 52.7962H35.3776C35.1601 52.7962 34.9514 52.8826 34.7976 53.0364C34.6437 53.1903 34.5573 53.3989 34.5573 53.6165C34.5573 53.8341 34.6437 54.0427 34.7976 54.1965C34.9514 54.3504 35.1601 54.4368 35.3776 54.4368H39.1958C39.4454 54.4347 39.693 54.482 39.9242 54.5761C40.1555 54.6701 40.3658 54.8091 40.5431 54.9848C40.7203 55.1606 40.861 55.3697 40.9571 55.6002C41.0531 55.8306 41.1025 56.0778 41.1025 56.3274C41.1025 56.5771 41.0531 56.8242 40.9571 57.0547C40.861 57.2851 40.7203 57.4942 40.5431 57.67C40.3658 57.8458 40.1555 57.9847 39.9242 58.0788C39.693 58.1728 39.4454 58.2202 39.1958 58.218H33.6909C33.4734 58.218 33.2647 58.3045 33.1109 58.4583C32.957 58.6121 32.8706 58.8208 32.8706 59.0383C32.8706 59.2559 32.957 59.4646 33.1109 59.6184C33.2647 59.7722 33.4734 59.8587 33.6909 59.8587H37.9589C38.207 59.8565 38.453 59.9036 38.6829 59.9971C38.9127 60.0905 39.1217 60.2286 39.2979 60.4033C39.4741 60.578 39.6139 60.7858 39.7094 61.0149C39.8048 61.2439 39.854 61.4895 39.854 61.7377C39.854 61.9858 39.8048 62.2314 39.7094 62.4604C39.6139 62.6895 39.4741 62.8973 39.2979 63.072C39.1217 63.2467 38.9127 63.3848 38.6829 63.4782C38.453 63.5717 38.207 63.6188 37.9589 63.6166H30.0598C27.3409 63.6166 24.7189 63.5041 22.5277 62.1447C20.0064 60.58 17.0979 59.7513 14.1306 59.7522H12.7116V43.2711H14.3194ZM3.00781 39.7119H11.0709V62.9013H3.00781V39.7119Z"
                      fill="url(#paint0_linear_294_12126)"
                    />
                    <path
                      d="M59.512 26.5573C59.3395 26.6856 59.2243 26.8766 59.1912 27.089C59.1581 27.3014 59.2097 27.5184 59.3349 27.6931C59.4602 27.8679 59.649 27.9865 59.8608 28.0235C60.0726 28.0604 60.2904 28.0127 60.4674 27.8907C61.9083 26.8583 63.0139 25.4251 63.6465 23.7692C64.2791 22.1134 64.4109 20.3081 64.0255 18.5779C63.64 16.8478 62.7544 15.2692 61.4787 14.0385C60.203 12.8078 58.5935 11.9794 56.8507 11.6563C56.6367 11.6167 56.4158 11.6636 56.2365 11.7869C56.0572 11.9102 55.9342 12.0996 55.8946 12.3135C55.855 12.5274 55.9019 12.7484 56.0252 12.9277C56.1484 13.107 56.3379 13.23 56.5518 13.2696C57.9784 13.5339 59.2958 14.2119 60.34 15.2192C61.3843 16.2266 62.1092 17.5187 62.4247 18.9349C62.7402 20.3511 62.6323 21.8288 62.1144 23.1841C61.5965 24.5394 60.6915 25.7125 59.512 26.5574V26.5573Z"
                      fill="url(#paint1_linear_294_12126)"
                    />
                    <path
                      d="M57.7178 7.40434C57.5038 7.36473 57.2829 7.41172 57.1036 7.53498C56.9244 7.65825 56.8014 7.84768 56.7618 8.06162C56.7221 8.27555 56.7691 8.49646 56.8924 8.67575C57.0157 8.85503 57.2051 8.97801 57.419 9.01762C59.6758 9.43591 61.7598 10.5085 63.4116 12.1021C65.0634 13.6956 66.2103 15.7397 66.7093 17.98C67.2084 20.2203 67.0377 22.5579 66.2185 24.7019C65.3993 26.8459 63.9677 28.7017 62.1019 30.0384C61.925 30.1651 61.8057 30.3569 61.7703 30.5715C61.7348 30.7862 61.786 31.0061 61.9127 31.183C62.0394 31.3599 62.2312 31.4792 62.4458 31.5147C62.6605 31.5502 62.8804 31.4989 63.0573 31.3722C65.1848 29.8482 66.8171 27.7322 67.7512 25.2875C68.6853 22.8429 68.8799 20.1775 68.3109 17.6231C67.7418 15.0687 66.4342 12.7381 64.5507 10.9211C62.6672 9.10417 60.291 7.88119 57.7178 7.40434Z"
                      fill="url(#paint2_linear_294_12126)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_294_12126"
                        x1="29.9906"
                        y1="4.74219"
                        x2="29.9906"
                        y2="65.257"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#002A57" />
                        <stop offset="1" stop-color="#FFA500" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_294_12126"
                        x1="60.0613"
                        y1="11.6426"
                        x2="60.0613"
                        y2="28.0357"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#002A57" />
                        <stop offset="1" stop-color="#FFA500" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_294_12126"
                        x1="62.6891"
                        y1="7.39062"
                        x2="62.6891"
                        y2="31.5257"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#002A57" />
                        <stop offset="1" stop-color="#FFA500" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="font-primary text-[24px] font-bold leading-[33.6px] text-custom-blue">
                  Civic Engagement
                </div>
                <div className="font-secondary text-[15.88px] leading-[24px] text-custom-lightgray">
                  We foster civic participation to ensure every voice is heard
                  and valued.
                </div>
              </div>
              <div
                className="font-primary text-[14px] leading-[18px] text-left text-custom-orange mt-auto flex items-center cursor-pointer"
                onClick={() => (window.location.href = "/donate")}
              >
                Donate
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35731 16.1874C8.22969 16.4265 8.29933 16.7311 8.52942 16.8943C8.77868 17.071 9.12233 17.0151 9.29649 16.7695L14.8426 8.94793L15.6947 13.7986L15.7124 13.8712C15.7945 14.1297 16.0578 14.2965 16.3326 14.2527C16.6319 14.2046 16.8323 13.9232 16.7797 13.6247L15.6972 7.46322L15.6798 7.39143C15.6431 7.27488 15.5683 7.17479 15.4705 7.10541C15.412 7.064 15.3457 7.03386 15.2743 7.01713C15.0563 6.96598 14.8313 7.04981 14.7034 7.23017L8.39335 16.1291L8.35731 16.1874ZM8.44057 8.65675C8.49475 8.9555 8.78074 9.15829 9.08023 9.10853L12.4847 8.54748L12.5576 8.53044C12.8162 8.45109 12.9791 8.19162 12.9294 7.91777C12.9024 7.76839 12.8181 7.64354 12.7031 7.562C12.5869 7.4796 12.4406 7.44094 12.2898 7.46599L8.88569 8.02644L8.813 8.0436C8.55476 8.12335 8.39146 8.38329 8.44057 8.65675Z"
                    fill="#FFA500"
                  />
                </svg>
              </div>
            </div>
            <div
              className="w-[380px] h-[339px] rounded-[20px] flex flex-col p-[20px]"
              style={{ border: "1px solid rgba(227, 227, 227, 1)" }}
            >
              {" "}
              <div className="flex flex-col items-left gap-[8px]">
                <div style={{ marginBottom: "48px" }}>
                  
                  <svg
                    width="70"
                    height="70"
                    viewBox="0 0 70 70"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M69.7953 33.152L62.126 12.5036C61.8228 11.687 61.2177 11.0368 60.4224 10.6721C59.6267 10.3082 58.7396 10.274 57.923 10.5767L52.7898 12.483C51.0999 13.1108 50.2356 14.9966 50.8631 16.6864L50.9464 16.9106C49.7319 17.3716 48.3765 16.8681 46.3047 16.0003C43.2111 14.7052 39.0154 12.9661 33.6889 16.2976C29.3659 13.6068 25.9738 14.2706 22.9696 14.8687C21.4437 15.172 19.9903 15.4574 18.4892 15.3021C18.447 14.9077 18.3388 14.519 18.1522 14.1544C17.7531 13.3753 17.0769 12.7989 16.2484 12.5316L11.0374 10.8507C10.2084 10.5834 9.32291 10.6561 8.54416 11.0543C7.76541 11.4533 7.18901 12.1296 6.922 12.9581L0.158109 33.9209C-0.395192 35.6366 0.550355 37.4825 2.26618 38.0358L7.47707 39.7174C7.80588 39.8236 8.14344 39.8762 8.47963 39.8762C8.99137 39.8762 9.5001 39.7543 9.97001 39.5138C10.2603 39.365 10.5111 39.1669 10.7396 38.9476C10.7717 39.1062 10.8148 39.263 10.8536 39.4205L9.54905 41.8595C8.98959 42.906 8.88118 44.1751 9.25223 45.3407C9.61344 46.4758 10.3752 47.3822 11.3744 47.8814C12.2451 48.3473 13.2044 48.4929 14.1152 48.3587C13.855 49.2215 13.8599 50.1677 14.142 51.0545C14.5032 52.1895 15.265 53.0962 16.2641 53.5954C17.3092 54.1543 18.5122 54.2709 19.6522 53.9261C20.1076 53.7879 20.5307 53.5828 20.91 53.3192C21.2758 54.4366 22.0317 55.3284 23.0195 55.822C24.0643 56.3809 25.2673 56.4975 26.4073 56.1527C26.6604 56.0758 26.9037 55.9784 27.1346 55.8618C27.4774 57.2379 28.4559 58.4634 29.6756 59.1158C30.2581 59.4271 30.9442 59.6278 31.6563 59.6278C32.9505 59.6278 34.3306 58.9646 35.3289 57.0985L35.5236 56.7343C35.5994 56.774 35.6749 56.8138 35.7442 56.85L36.2648 57.1215C36.9025 57.4498 37.5258 57.5944 38.1118 57.5944C39.5737 57.5944 40.8017 56.6934 41.4295 55.4969C41.8618 54.6736 42.014 53.6947 41.8043 52.7445C42.3317 52.7718 42.8651 52.709 43.3864 52.5511C44.5571 52.1964 45.5178 51.4104 46.0915 50.3378C46.555 49.4713 46.7227 48.4987 46.583 47.5394C47.5622 47.9459 48.6451 47.9988 49.6779 47.686C50.8588 47.3282 51.8278 46.535 52.4064 45.4533C52.8793 44.5685 53.0472 43.5743 52.897 42.5958C54.4929 43.232 56.0327 42.941 57.1019 41.7696C58.1858 40.5825 58.5503 38.7637 58.1449 37.1407C58.2287 37.1107 58.3136 37.0802 58.408 37.0463L58.423 37.0409L58.5324 37.3352C59.0214 38.6509 60.2731 39.4659 61.6007 39.4659C61.9782 39.4659 62.3616 39.4003 62.7354 39.2615L67.8683 37.3553C69.5585 36.7274 70.4228 34.8421 69.7953 33.152ZM9.79213 37.0289C9.67975 37.3769 9.4368 37.6614 9.10758 37.8298C8.77782 37.9982 8.40526 38.0293 8.05785 37.9173L2.84668 36.2354C2.12371 36.0023 1.72518 35.2245 1.95828 34.5015L8.72244 13.5389C8.83455 13.1912 9.0775 12.9067 9.40659 12.7382C9.60551 12.6364 9.82071 12.5846 10.0366 12.5846C10.1777 12.5846 10.3186 12.6064 10.456 12.6507C10.4563 12.6507 10.4563 12.6507 10.4563 12.651L15.6675 14.3322C16.0152 14.4443 16.2997 14.6873 16.4681 15.0164C16.6365 15.3456 16.6676 15.7182 16.5556 16.0661L11.1556 32.8029C11.132 32.8486 11.1091 32.8954 11.0929 32.9459C11.0454 33.0922 11.0088 33.2403 10.9671 33.3875L9.79213 37.0289ZM12.2435 46.2012C11.6819 45.9207 11.2597 45.4114 11.055 44.7672C10.8379 44.0851 10.8971 43.3505 11.2173 42.7518L12.6911 39.9963C12.6914 39.996 12.6918 39.9957 12.6919 39.9953L13.3959 38.679C14.0517 37.4534 15.5714 36.9798 16.8046 37.6022C17.6135 38.1678 18.8269 39.3705 17.9063 41.0915L17.4046 42.0294L15.7259 45.1681C15.0598 46.4084 13.5091 46.8788 12.2435 46.2012ZM20.6177 50.8783C20.2975 51.4775 19.7595 51.9169 19.103 52.1158C18.4468 52.3148 17.7552 52.2476 17.1332 51.9154C16.5716 51.6349 16.1494 51.1253 15.9447 50.4811C15.7276 49.7994 15.7871 49.0647 16.1073 48.4661L17.3941 46.0607L19.0729 42.922C19.3931 42.3231 19.9311 41.8838 20.5872 41.6849C21.2437 41.4854 21.9347 41.5528 22.5342 41.8733C23.1331 42.1935 23.5724 42.7315 23.7714 43.388C23.9703 44.0441 23.9031 44.7357 23.5825 45.335L23.1111 46.2168C23.1109 46.2178 23.1102 46.2186 23.1096 46.2196L21.1943 49.8004C21.1943 49.8006 21.1943 49.8006 21.1941 49.8009L20.6177 50.8783ZM25.8584 54.3423C25.2018 54.5412 24.5109 54.4741 23.8887 54.1419C23.327 53.8613 22.9051 53.352 22.7002 52.708C22.4837 52.0268 22.5422 51.2937 22.8612 50.6955L22.8627 50.6927L24.778 47.1119C24.7781 47.1115 24.7783 47.1111 24.7784 47.1107L24.7795 47.1089C25.1001 46.5112 25.6374 46.0731 26.2926 45.8745C26.9484 45.6746 27.6401 45.7421 28.2392 46.0629C29.4825 46.728 29.9531 48.2809 29.2882 49.5242L28.3306 51.3148L27.4818 52.9018C27.4815 52.9024 27.4811 52.9031 27.4808 52.9036L27.3731 53.105C27.0529 53.7037 26.5146 54.1434 25.8584 54.3423ZM30.5678 57.4476C29.3277 56.7844 28.4404 55.1206 29.1501 53.7938L29.999 52.2067L30 52.2046C30.331 51.5875 30.9194 51.0918 31.615 50.8448C32.3094 50.5978 33.0066 50.6308 33.5786 50.9368C34.8251 51.6031 35.0262 52.1862 35.0686 52.5669C35.1332 53.1423 34.8896 53.9075 34.2797 55.0478C34.2793 55.0487 34.279 55.0497 34.2786 55.0505L33.6605 56.2062C32.6135 58.1654 31.2738 57.8248 30.5678 57.4476ZM39.7545 54.6182C39.3083 55.4695 38.3242 56.054 37.1307 55.44L36.6239 55.1755C36.5401 55.1312 36.4619 55.0901 36.3893 55.0523C36.7723 54.2002 37.0515 53.2744 36.9487 52.3565C36.8328 51.3214 36.2584 50.4581 35.2164 49.7301L38.9418 51.7307C40.1868 52.6049 40.1825 53.8027 39.7545 54.6182ZM55.7046 40.4943C55.0955 41.1622 54.2595 41.2188 53.2191 40.6618L50.5211 39.2189C50.5191 39.2179 50.5174 39.217 50.5154 39.2161C50.4878 39.2014 50.459 39.1929 50.4307 39.1811L41.7309 34.4587C41.2727 34.209 40.6978 34.3796 40.4484 34.839C40.1993 35.2981 40.3693 35.872 40.8287 36.1214L49.7125 40.9437C50.3005 41.2885 50.7372 41.8309 50.9382 42.4932C51.1494 43.1903 51.0783 43.9246 50.7378 44.5612C50.3975 45.1976 49.826 45.6645 49.1288 45.8757C48.4305 46.0867 47.6967 46.0159 47.0608 45.6756L44.3784 44.2408C44.3318 44.2028 44.2815 44.1681 44.2265 44.1387L37.7529 40.6774C37.2916 40.4305 36.7189 40.6053 36.4729 41.0657C36.2266 41.5263 36.4002 42.0994 36.8612 42.3456L43.1721 45.72C43.2189 45.7583 43.2696 45.7931 43.325 45.8227C43.9523 46.158 44.4123 46.7209 44.6204 47.4082C44.8285 48.0952 44.7584 48.8187 44.423 49.4457C44.0876 50.073 43.5245 50.5326 42.8375 50.7411C42.1509 50.9489 41.4269 50.8791 40.7999 50.5437L39.4306 49.8114C39.3617 49.7747 39.29 49.7502 39.2177 49.7317L33.6907 46.764C33.2304 46.5151 32.6567 46.6892 32.4101 47.1498C32.1627 47.6099 32.3355 48.1835 32.7959 48.4304L33.9574 49.0541C33.1688 48.7635 32.3051 48.7085 31.4407 48.9237C31.6849 47.1328 30.8156 45.2952 29.1313 44.3942C28.0963 43.8407 26.9054 43.7202 25.775 44.0543C25.7669 43.6479 25.7029 43.2396 25.5816 42.8391C25.2362 41.6988 24.4704 40.7634 23.4259 40.2048C22.3759 39.6437 21.1997 39.547 20.1352 39.8438C20.117 38.2368 19.0969 36.9004 17.8822 36.0475C17.8406 36.0156 17.7963 35.9868 17.7492 35.9617C15.9356 34.9921 13.7437 35.4111 12.4003 36.846C12.3786 35.8623 12.5131 34.8745 12.7864 33.9078L18.1853 17.1743C20.0104 17.3856 21.699 17.0507 23.3381 16.724C26.0632 16.182 28.6513 15.6669 31.9955 17.4898C31.267 18.0699 30.5341 18.7318 29.8056 19.4678C29.2289 20.051 28.6358 20.6333 28.0572 21.2014C25.9479 23.2731 24.1263 25.0623 23.6054 26.3322C23.4795 26.6391 23.5235 26.9895 23.7214 27.2556C27.4864 32.319 32.0491 30.6008 35.7139 29.2208C38.4614 28.1858 40.8343 27.2917 42.7245 28.7875C42.7602 28.8158 42.7978 28.8414 42.8372 28.8642C43.7399 29.3873 44.9834 30.0013 46.4232 30.7124C49.9042 32.4317 54.6717 34.7865 55.9037 36.659C56.7315 37.9164 56.4689 39.6571 55.7046 40.4943ZM57.3372 35.4212C55.6857 33.1816 51.0306 30.8779 47.2614 29.0166C45.8826 28.3355 44.6875 27.7456 43.8419 27.2599C41.1267 25.1615 38.0367 26.3248 35.0475 27.4505C31.5046 28.7841 28.4239 29.9437 25.6098 26.5958C26.2708 25.608 27.8493 24.0579 29.383 22.5516C29.968 21.977 30.5672 21.3883 31.1505 20.7989C32.1611 19.7782 33.1724 18.9196 34.1584 18.241C38.9236 14.9641 42.4562 16.4406 45.5738 17.7453C47.0314 18.3556 48.5194 18.9785 49.9911 18.9785C50.5317 18.9785 51.0694 18.8798 51.6035 18.6803L57.7641 35.2676C57.6206 35.3192 57.4753 35.3716 57.3372 35.4212ZM67.21 35.5817L62.0771 37.488C61.3627 37.7516 60.5697 37.3882 60.3056 36.6763L52.6366 16.0273C52.5095 15.6849 52.5243 15.3114 52.6782 14.9751C52.8324 14.6389 53.1059 14.3836 53.4483 14.2564L58.5813 12.3501C58.7355 12.2928 58.896 12.2642 59.0564 12.2642C59.2529 12.2642 59.4491 12.307 59.634 12.3916C59.97 12.5456 60.2252 12.8193 60.3524 13.1621L68.0216 33.8106C68.2862 34.5229 67.9219 35.3172 67.21 35.5817Z"
                      fill="url(#paint0_linear_294_12131)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_294_12131"
                        x1="35"
                        y1="10.3721"
                        x2="35"
                        y2="59.6278"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#002A57" />
                        <stop offset="1" stopColor="#FFA500" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="font-primary text-[24px] font-bold leading-[33.6px] text-custom-blue">
                  Fair Economy
                </div>
                <div className="font-secondary text-[15.88px] leading-[24px] text-custom-lightgray">
                  We advocate for fair policies and practices to create
                  sustainable communities.
                </div>
              </div>
              <div
                className="font-primary text-[14px] leading-[18px] text-left text-custom-orange mt-auto flex items-center cursor-pointer"
                onClick={() => (window.location.href = "/donate")}
              >
                Donate
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35731 16.1874C8.22969 16.4265 8.29933 16.7311 8.52942 16.8943C8.77868 17.071 9.12233 17.0151 9.29649 16.7695L14.8426 8.94793L15.6947 13.7986L15.7124 13.8712C15.7945 14.1297 16.0578 14.2965 16.3326 14.2527C16.6319 14.2046 16.8323 13.9232 16.7797 13.6247L15.6972 7.46322L15.6798 7.39143C15.6431 7.27488 15.5683 7.17479 15.4705 7.10541C15.412 7.064 15.3457 7.03386 15.2743 7.01713C15.0563 6.96598 14.8313 7.04981 14.7034 7.23017L8.39335 16.1291L8.35731 16.1874ZM8.44057 8.65675C8.49475 8.9555 8.78074 9.15829 9.08023 9.10853L12.4847 8.54748L12.5576 8.53044C12.8162 8.45109 12.9791 8.19162 12.9294 7.91777C12.9024 7.76839 12.8181 7.64354 12.7031 7.562C12.5869 7.4796 12.4406 7.44094 12.2898 7.46599L8.88569 8.02644L8.813 8.0436C8.55476 8.12335 8.39146 8.38329 8.44057 8.65675Z"
                    fill="#FFA500"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="relative w-full max-w-[1440px] h-auto px-4 py-8 md:py-[50px] mx-auto box-border">
        <div className="w-full max-w-[1200px] h-auto mx-auto">
          <div className="flex flex-col items-start">
            <div className="flex items-center gap-2.5">
              <div className="w-[72px] h-0 border-t-2 border-custom-orange mr-2.5"></div>
              <div className="h-[22px] font-primary text-[16px] font-bold leading-[21.86px] tracking-[2px] text-custom-orange whitespace-nowrap">
                OUR IMPACT
              </div>
            </div>
            <div className="mt-6 w-full flex justify-between items-center  mb-8">
              <p className="font-primary text-[24px] md:text-[32px] font-bold leading-[28.8px] md:leading-[38.4px] text-custom-blue whitespace-nowrap">
                {" "}
                How do we help?
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-center items-center gap-[30px]">
            {/* First Box */}
            <div
              className="w-full md:w-[380px] h-auto md:h-[339px] rounded-[20px] flex flex-col p-[20px]"
              style={{ border: "1px solid rgba(227, 227, 227, 1)" }}
            >
              <div className="flex flex-col items-start gap-2">
                <div style={{ marginBottom: "48px" }}>
                  {/* SVG for Racial Equity */}
                  <svg
                    width="64"
                    height="65"
                    viewBox="0 0 64 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_294_12106"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="64"
                      height="65"
                    >
                      <path d="M0 0H64V64.1H0V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_294_12106)">
                      <path
                        d="M53.1 22.635V13.7211C54.3 13.3205 55.1 12.2188 55.1 10.9167V9.91516H53.1V10.9167C53.1 11.5177 52.7 11.9183 52.1 11.9183C51.5 11.9183 51.1 11.5177 51.1 10.9167C51.1 9.21407 49.8 7.91204 48.1 7.91204H36.2V6.30954L32.1 0.0998535L28 6.30954V7.81188H16C14.3 7.81188 13 9.11391 13 10.8166C13 11.4175 12.6 11.8181 12 11.8181C11.4 11.8181 11 11.4175 11 10.8166V9.81501H9V10.8166C9 12.1186 9.8 13.2203 11 13.6209V22.5348L0 42.5661V42.8666C0 46.7727 3.1 49.8775 7 49.8775H17C20.9 49.8775 24 46.7727 24 42.8666V42.5661L13 22.5348V13.6209C14.2 13.2203 15 12.1186 15 10.8166C15 10.2156 15.4 9.81501 16 9.81501H28.1V11.8181H31V14.0216C29.3 14.5224 28.1 16.0247 28.1 17.8275C28.1 19.6303 29.3 21.2328 31 21.6334V24.0372C29.3 24.538 28 26.0403 28 27.8431V47.5739L30.4 48.7758L26 54.1842V55.8869C22.6 56.3877 20 59.3923 20 62.8978V63.8994H44V62.8978C44 59.3923 41.4 56.4878 38.1 55.8869V54.0841L33.5 48.7758L36.1 47.5739L36 27.8431C36 25.9402 34.7 24.4378 33 24.0372V21.8338C34.8 21.5333 36.2 19.8306 36.2 17.9277C36.2 16.0247 34.8 14.322 33 14.0216V11.9183H36.2V9.91516H48C48.6 9.91516 49 10.3158 49 10.9167C49 12.2188 49.8 13.3205 51 13.7211V22.635L40 42.6663V42.9667C40 46.8728 43.1 49.9777 47 49.9777H57C60.9 49.9777 64 46.8728 64 42.9667V42.6663L53.1 22.635ZM17 47.8744H7C4.6 47.8744 2.6 46.1717 2.1 43.8681H21.9C21.4 46.1717 19.4 47.8744 17 47.8744ZM21.3 41.865H2.7L12 24.9386L21.3 41.865ZM41.9 61.8963H22.1C22.6 59.4925 24.6 57.7898 27.1 57.7898H36.9C39.4 57.7898 41.4 59.5927 41.9 61.8963ZM36.1 54.8853V55.7867H28V54.8853L32 50.0778L36.1 54.8853ZM34 27.8431L34.1 46.372L32 47.3736L30 46.372V27.8431C30 26.7414 30.9 25.84 32 25.84C33.1 25.84 34 26.7414 34 27.8431ZM34.2 17.8275C34.2 18.9292 33.3 19.8306 32.2 19.8306H32C30.9 19.8306 30 18.9292 30 17.8275C30 16.7258 30.9 15.8244 32 15.8244H32.2C33.4 15.8244 34.2 16.7258 34.2 17.8275ZM34.2 9.81501H30V6.91048L32.1 3.70548L34.2 6.91048V9.81501ZM52.1 24.9386L61.4 41.865H42.8L52.1 24.9386ZM57.1 47.8744H47.1C44.7 47.8744 42.7 46.1717 42.2 43.8681H62C61.5 46.1717 59.5 47.8744 57.1 47.8744Z"
                        fill="url(#paint0_linear_294_12106)"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_294_12106"
                        x1="32"
                        y1="0.0998535"
                        x2="32"
                        y2="63.8994"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#002A57" />
                        <stop offset="1" stopColor="#FFA500" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="font-primary text-[24px] font-bold leading-[33.6px] text-custom-blue">
                  Racial Equity
                </div>
                <div className="font-secondary text-[16px] leading-[24px] text-custom-lightgray">
                  We work to eliminate racial disparities and promote equal
                  opportunities for all community members.
                </div>
              </div>
              {/* <div
                className="font-primary text-[14px] leading-[18px] text-left text-custom-orange mt-auto flex items-center cursor-pointer"
                onClick={() => (window.location.href = "/donate")}
              >
                Donate
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35731 16.1874C8.22969 16.4265 8.29933 16.7311 8.52942 16.8943C8.77868 17.071 9.12233 17.0151 9.29649 16.7695L14.8426 8.94793L15.6947 13.7986L15.7124 13.8712C15.7945 14.1297 16.0578 14.2965 16.3326 14.2527C16.6319 14.2046 16.8323 13.9232 16.7797 13.6247L15.6972 7.46322L15.6798 7.39143C15.6431 7.27488 15.5683 7.17479 15.4705 7.10541C15.412 7.064 15.3457 7.03386 15.2743 7.01713C15.0563 6.96598 14.8313 7.04981 14.7034 7.23017L8.39335 16.1291L8.35731 16.1874ZM8.44057 8.65675C8.49475 8.9555 8.78074 9.15829 9.08023 9.10853L12.4847 8.54748L12.5576 8.53044C12.8162 8.45109 12.9791 8.19162 12.9294 7.91777C12.9024 7.76839 12.8181 7.64354 12.7031 7.562C12.5869 7.4796 12.4406 7.44094 12.2898 7.46599L8.88569 8.02644L8.813 8.0436C8.55476 8.12335 8.39146 8.38329 8.44057 8.65675Z"
                    fill="#FFA500"
                  />
                </svg>
              </div> */}
            </div>
            {/* Second Box */}
            <div
              className="w-full md:w-[380px] h-auto md:h-[339px] rounded-[20px] flex flex-col p-[20px]"
              style={{ border: "1px solid rgba(227, 227, 227, 1)" }}
            >
              <div className="flex flex-col items-start gap-2">
                <div style={{ marginBottom: "48px" }}>
                  {/* SVG for Civic Engagement */}
                  <svg
                    width="70"
                    height="70"
                    viewBox="0 0 70 70"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.1875 64.542H11.8912C12.1088 64.542 12.3175 64.4555 12.4713 64.3017C12.6251 64.1479 12.7116 63.9392 12.7116 63.7216V61.3921H14.1306C16.7923 61.3915 19.4012 62.1349 21.6628 63.5386C24.221 65.1257 27.0945 65.257 30.0598 65.257H37.9589C38.6236 65.2575 39.2749 65.0697 39.8373 64.7152C40.3996 64.3607 40.85 63.8541 41.1362 63.2541C41.4223 62.6541 41.5326 61.9853 41.4542 61.3252C41.3759 60.665 41.112 60.0407 40.6932 59.5244C41.2343 59.2715 41.7022 58.8854 42.0533 58.4023C42.4044 57.9192 42.6272 57.3549 42.7007 56.7622C42.7741 56.1695 42.696 55.5679 42.4735 55.0137C42.251 54.4594 41.8915 53.9708 41.4286 53.5934C41.831 53.258 42.1556 52.839 42.3797 52.3655C42.6039 51.8921 42.7223 51.3755 42.7268 50.8517C42.7313 50.3279 42.6217 49.8093 42.4056 49.3321C42.1895 48.8549 41.8722 48.4305 41.4755 48.0883C42.0166 47.6529 42.4093 47.0603 42.5992 46.3922C42.7892 45.7242 42.7671 45.0137 42.536 44.3587C42.305 43.7038 41.8763 43.1367 41.3092 42.7357C40.7421 42.3348 40.0646 42.1197 39.3701 42.1202H39.1439C41.5447 41.5323 43.0322 39.312 43.0322 36.1319V36.028C43.0322 35.8105 42.9458 35.6018 42.792 35.448C42.6381 35.2941 42.4295 35.2077 42.2119 35.2077H35.1641L34.2742 30.991C36.6697 30.9848 39.0587 31.2411 41.3984 31.7554L55.609 34.8948C55.6671 34.9077 55.7264 34.9142 55.7859 34.9142C55.9088 34.9142 56.0301 34.8866 56.1409 34.8334C56.2516 34.7802 56.349 34.7028 56.4259 34.607C56.5027 34.5111 56.5571 34.3992 56.5849 34.2795C56.6127 34.1598 56.6133 34.0354 56.5865 33.9155L54.7262 25.566C56.0867 25.0304 57.2112 24.0264 57.8971 22.7351C58.583 21.4437 58.7851 19.9499 58.4671 18.5227C58.1492 17.0955 57.3319 15.8288 56.1627 14.9508C54.9935 14.0728 53.5491 13.6412 52.0898 13.7339L50.2305 5.38403C50.2005 5.24939 50.137 5.1245 50.0459 5.0209C49.9548 4.9173 49.8391 4.83834 49.7094 4.79132C49.5798 4.7443 49.4403 4.73074 49.304 4.75189C49.1677 4.77305 49.0389 4.82823 48.9296 4.91235L37.3953 13.787C33.6024 16.6965 29.2217 18.7455 24.5574 19.7919C24.1116 19.8911 23.6897 20.0772 23.3158 20.3395C22.9419 20.6018 22.6234 20.9352 22.3783 21.3206C22.1333 21.706 21.9666 22.136 21.8877 22.5858C21.8089 23.0357 21.8194 23.4967 21.9188 23.9425L23.0744 29.13C23.2759 30.0298 23.826 30.813 24.6042 31.3077C25.3823 31.8024 26.325 31.9682 27.2252 31.7687C27.2609 31.7608 27.297 31.7542 27.3327 31.7464L28.1039 35.2083H23.4078C19.6391 35.2083 18.6993 38.0299 18.1944 39.5457C18.0819 39.8834 17.9293 40.3412 17.8274 40.474C16.5739 41.2523 15.4261 41.6308 14.3194 41.6308H12.7116V38.8916C12.7116 38.674 12.6251 38.4654 12.4713 38.3116C12.3175 38.1577 12.1088 38.0713 11.8912 38.0713H2.1875C1.96994 38.0713 1.76129 38.1577 1.60745 38.3116C1.45361 38.4654 1.36719 38.674 1.36719 38.8916V63.7216C1.36719 63.9392 1.45361 64.1479 1.60745 64.3017C1.76129 64.4555 1.96994 64.542 2.1875 64.542ZM41.3632 36.8485C41.0683 40.3498 38.6031 40.6364 37.8146 40.6364H36.3096L35.5102 36.8485H41.3632ZM54.8889 16.0641C55.5701 16.4972 56.1222 17.1058 56.487 17.8259C56.8518 18.546 57.016 19.3511 56.9622 20.1566C56.9085 20.9621 56.6388 21.7382 56.1815 22.4035C55.7242 23.0687 55.0962 23.5986 54.3635 23.9373L52.4531 15.3624C53.3158 15.3559 54.1619 15.5997 54.8889 16.0641ZM38.3957 15.0871L48.9094 6.99799L54.7055 33.0156L41.7528 30.1542C39.3187 29.6187 36.8337 29.3493 34.3414 29.3507C33.3043 29.3507 32.2688 29.3979 31.2349 29.4923L29.1534 20.152C32.4748 18.9459 35.5918 17.2378 38.3957 15.0871ZM24.6762 28.7733L23.5205 23.5858C23.4146 23.1102 23.5019 22.6121 23.7633 22.2009C24.0247 21.7897 24.4387 21.4992 24.9143 21.3932C25.8144 21.1927 26.7065 20.955 27.5904 20.6801L29.5947 29.6762C28.6788 29.8029 27.7701 29.9663 26.8688 30.1664C26.3934 30.2718 25.8955 30.1843 25.4845 29.9232C25.0735 29.662 24.7828 29.2485 24.6762 28.7733ZM32.6074 31.0371L34.9465 42.1208H31.3253L29.9307 35.864V35.8608L28.9447 31.4348C30.1572 31.2337 31.38 31.1009 32.6074 31.0371ZM14.3194 43.2711C15.7515 43.2711 17.1935 42.805 18.7273 41.846C19.2704 41.5065 19.493 40.8379 19.7509 40.064C20.2528 38.5569 20.8219 36.8486 23.4078 36.8486H28.4699L29.6445 42.1209H29.5761C29.2624 42.1211 28.9597 42.0054 28.7261 41.7959C28.4926 41.5864 28.3448 41.298 28.311 40.9861C28.2859 40.7712 28.1768 40.5748 28.0075 40.4399C27.8383 40.305 27.6226 40.2425 27.4074 40.266C27.1922 40.2894 26.9951 40.3969 26.8588 40.5651C26.7226 40.7333 26.6584 40.9485 26.6801 41.1639C26.757 41.878 27.0953 42.5384 27.63 43.018C28.1647 43.4976 28.8578 43.7624 29.5761 43.7615H39.3709C39.826 43.7615 40.2624 43.9423 40.5842 44.2641C40.9059 44.5859 41.0867 45.0223 41.0867 45.4773C41.0867 45.9324 40.9059 46.3688 40.5842 46.6906C40.2624 47.0124 39.826 47.1932 39.3709 47.1932H37.0357C36.9896 47.1934 36.9436 47.1976 36.8982 47.2055H35.3776C35.1601 47.2055 34.9514 47.2919 34.7976 47.4457C34.6437 47.5996 34.5573 47.8082 34.5573 48.0258C34.5573 48.2433 34.6437 48.452 34.7976 48.6058C34.9514 48.7597 35.1601 48.8461 35.3776 48.8461H39.1114C39.6352 48.8461 40.1376 49.0542 40.508 49.4246C40.8784 49.795 41.0864 50.2973 41.0864 50.8211C41.0864 51.345 40.8784 51.8473 40.508 52.2177C40.1376 52.5881 39.6352 52.7962 39.1114 52.7962H35.3776C35.1601 52.7962 34.9514 52.8826 34.7976 53.0364C34.6437 53.1903 34.5573 53.3989 34.5573 53.6165C34.5573 53.8341 34.6437 54.0427 34.7976 54.1965C34.9514 54.3504 35.1601 54.4368 35.3776 54.4368H39.1958C39.4454 54.4347 39.693 54.482 39.9242 54.5761C40.1555 54.6701 40.3658 54.8091 40.5431 54.9848C40.7203 55.1606 40.861 55.3697 40.9571 55.6002C41.0531 55.8306 41.1025 56.0778 41.1025 56.3274C41.1025 56.5771 41.0531 56.8242 40.9571 57.0547C40.861 57.2851 40.7203 57.4942 40.5431 57.67C40.3658 57.8458 40.1555 57.9847 39.9242 58.0788C39.693 58.1728 39.4454 58.2202 39.1958 58.218H33.6909C33.4734 58.218 33.2647 58.3045 33.1109 58.4583C32.957 58.6121 32.8706 58.8208 32.8706 59.0383C32.8706 59.2559 32.957 59.4646 33.1109 59.6184C33.2647 59.7722 33.4734 59.8587 33.6909 59.8587H37.9589C38.207 59.8565 38.453 59.9036 38.6829 59.9971C38.9127 60.0905 39.1217 60.2286 39.2979 60.4033C39.4741 60.578 39.6139 60.7858 39.7094 61.0149C39.8048 61.2439 39.854 61.4895 39.854 61.7377C39.854 61.9858 39.8048 62.2314 39.7094 62.4604C39.6139 62.6895 39.4741 62.8973 39.2979 63.072C39.1217 63.2467 38.9127 63.3848 38.6829 63.4782C38.453 63.5717 38.207 63.6188 37.9589 63.6166H30.0598C27.3409 63.6166 24.7189 63.5041 22.5277 62.1447C20.0064 60.58 17.0979 59.7513 14.1306 59.7522H12.7116V43.2711H14.3194ZM3.00781 39.7119H11.0709V62.9013H3.00781V39.7119Z"
                      fill="url(#paint0_linear_294_12126)"
                    />
                    <path
                      d="M59.512 26.5573C59.3395 26.6856 59.2243 26.8766 59.1912 27.089C59.1581 27.3014 59.2097 27.5184 59.3349 27.6931C59.4602 27.8679 59.649 27.9865 59.8608 28.0235C60.0726 28.0604 60.2904 28.0127 60.4674 27.8907C61.9083 26.8583 63.0139 25.4251 63.6465 23.7692C64.2791 22.1134 64.4109 20.3081 64.0255 18.5779C63.64 16.8478 62.7544 15.2692 61.4787 14.0385C60.203 12.8078 58.5935 11.9794 56.8507 11.6563C56.6367 11.6167 56.4158 11.6636 56.2365 11.7869C56.0572 11.9102 55.9342 12.0996 55.8946 12.3135C55.855 12.5274 55.9019 12.7484 56.0252 12.9277C56.1484 13.107 56.3379 13.23 56.5518 13.2696C57.9784 13.5339 59.2958 14.2119 60.34 15.2192C61.3843 16.2266 62.1092 17.5187 62.4247 18.9349C62.7402 20.3511 62.6323 21.8288 62.1144 23.1841C61.5965 24.5394 60.6915 25.7125 59.512 26.5574V26.5573Z"
                      fill="url(#paint1_linear_294_12126)"
                    />
                    <path
                      d="M57.7178 7.40434C57.5038 7.36473 57.2829 7.41172 57.1036 7.53498C56.9244 7.65825 56.8014 7.84768 56.7618 8.06162C56.7221 8.27555 56.7691 8.49646 56.8924 8.67575C57.0157 8.85503 57.2051 8.97801 57.419 9.01762C59.6758 9.43591 61.7598 10.5085 63.4116 12.1021C65.0634 13.6956 66.2103 15.7397 66.7093 17.98C67.2084 20.2203 67.0377 22.5579 66.2185 24.7019C65.3993 26.8459 63.9677 28.7017 62.1019 30.0384C61.925 30.1651 61.8057 30.3569 61.7703 30.5715C61.7348 30.7862 61.786 31.0061 61.9127 31.183C62.0394 31.3599 62.2312 31.4792 62.4458 31.5147C62.6605 31.5502 62.8804 31.4989 63.0573 31.3722C65.1848 29.8482 66.8171 27.7322 67.7512 25.2875C68.6853 22.8429 68.8799 20.1775 68.3109 17.6231C67.7418 15.0687 66.4342 12.7381 64.5507 10.9211C62.6672 9.10417 60.291 7.88119 57.7178 7.40434Z"
                      fill="url(#paint2_linear_294_12126)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_294_12126"
                        x1="29.9906"
                        y1="4.74219"
                        x2="29.9906"
                        y2="65.257"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#002A57" />
                        <stop offset="1" stop-color="#FFA500" />
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_294_12126"
                        x1="60.0613"
                        y1="11.6426"
                        x2="60.0613"
                        y2="28.0357"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#002A57" />
                        <stop offset="1" stop-color="#FFA500" />
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_294_12126"
                        x1="62.6891"
                        y1="7.39062"
                        x2="62.6891"
                        y2="31.5257"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#002A57" />
                        <stop offset="1" stop-color="#FFA500" />
                      </linearGradient>
                    </defs>
                  </svg>
                  {/* Insert your SVG code here */}
                </div>
                <div className="font-primary text-[24px] font-bold leading-[33.6px] text-custom-blue">
                  Civic Engagement
                </div>
                <div className="font-secondary text-[16px] leading-[24px] text-custom-lightgray">
                  We foster civic participation to ensure every voice is heard
                  and valued.
                </div>
              </div>
              {/* <div
                className="font-primary text-[14px] leading-[18px] text-left text-custom-orange mt-auto flex items-center cursor-pointer"
                onClick={() => (window.location.href = "/donate")}
              >
                Donate
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35731 16.1874C8.22969 16.4265 8.29933 16.7311 8.52942 16.8943C8.77868 17.071 9.12233 17.0151 9.29649 16.7695L14.8426 8.94793L15.6947 13.7986L15.7124 13.8712C15.7945 14.1297 16.0578 14.2965 16.3326 14.2527C16.6319 14.2046 16.8323 13.9232 16.7797 13.6247L15.6972 7.46322L15.6798 7.39143C15.6431 7.27488 15.5683 7.17479 15.4705 7.10541C15.412 7.064 15.3457 7.03386 15.2743 7.01713C15.0563 6.96598 14.8313 7.04981 14.7034 7.23017L8.39335 16.1291L8.35731 16.1874ZM8.44057 8.65675C8.49475 8.9555 8.78074 9.15829 9.08023 9.10853L12.4847 8.54748L12.5576 8.53044C12.8162 8.45109 12.9791 8.19162 12.9294 7.91777C12.9024 7.76839 12.8181 7.64354 12.7031 7.562C12.5869 7.4796 12.4406 7.44094 12.2898 7.46599L8.88569 8.02644L8.813 8.0436C8.55476 8.12335 8.39146 8.38329 8.44057 8.65675Z"
                    fill="#FFA500"
                  />
                </svg>
              </div> */}
            </div>
            {/* Third Box */}
            <div
              className="w-full md:w-[380px] h-auto md:h-[339px] rounded-[20px] flex flex-col p-[20px]"
              style={{ border: "1px solid rgba(227, 227, 227, 1)" }}
            >
              <div className="flex flex-col items-start gap-2">
                <div style={{ marginBottom: "48px" }}>
                  {/* SVG for Fair Economy */}
                  <svg
                    width="70"
                    height="70"
                    viewBox="0 0 70 70"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M69.7953 33.152L62.126 12.5036C61.8228 11.687 61.2177 11.0368 60.4224 10.6721C59.6267 10.3082 58.7396 10.274 57.923 10.5767L52.7898 12.483C51.0999 13.1108 50.2356 14.9966 50.8631 16.6864L50.9464 16.9106C49.7319 17.3716 48.3765 16.8681 46.3047 16.0003C43.2111 14.7052 39.0154 12.9661 33.6889 16.2976C29.3659 13.6068 25.9738 14.2706 22.9696 14.8687C21.4437 15.172 19.9903 15.4574 18.4892 15.3021C18.447 14.9077 18.3388 14.519 18.1522 14.1544C17.7531 13.3753 17.0769 12.7989 16.2484 12.5316L11.0374 10.8507C10.2084 10.5834 9.32291 10.6561 8.54416 11.0543C7.76541 11.4533 7.18901 12.1296 6.922 12.9581L0.158109 33.9209C-0.395192 35.6366 0.550355 37.4825 2.26618 38.0358L7.47707 39.7174C7.80588 39.8236 8.14344 39.8762 8.47963 39.8762C8.99137 39.8762 9.5001 39.7543 9.97001 39.5138C10.2603 39.365 10.5111 39.1669 10.7396 38.9476C10.7717 39.1062 10.8148 39.263 10.8536 39.4205L9.54905 41.8595C8.98959 42.906 8.88118 44.1751 9.25223 45.3407C9.61344 46.4758 10.3752 47.3822 11.3744 47.8814C12.2451 48.3473 13.2044 48.4929 14.1152 48.3587C13.855 49.2215 13.8599 50.1677 14.142 51.0545C14.5032 52.1895 15.265 53.0962 16.2641 53.5954C17.3092 54.1543 18.5122 54.2709 19.6522 53.9261C20.1076 53.7879 20.5307 53.5828 20.91 53.3192C21.2758 54.4366 22.0317 55.3284 23.0195 55.822C24.0643 56.3809 25.2673 56.4975 26.4073 56.1527C26.6604 56.0758 26.9037 55.9784 27.1346 55.8618C27.4774 57.2379 28.4559 58.4634 29.6756 59.1158C30.2581 59.4271 30.9442 59.6278 31.6563 59.6278C32.9505 59.6278 34.3306 58.9646 35.3289 57.0985L35.5236 56.7343C35.5994 56.774 35.6749 56.8138 35.7442 56.85L36.2648 57.1215C36.9025 57.4498 37.5258 57.5944 38.1118 57.5944C39.5737 57.5944 40.8017 56.6934 41.4295 55.4969C41.8618 54.6736 42.014 53.6947 41.8043 52.7445C42.3317 52.7718 42.8651 52.709 43.3864 52.5511C44.5571 52.1964 45.5178 51.4104 46.0915 50.3378C46.555 49.4713 46.7227 48.4987 46.583 47.5394C47.5622 47.9459 48.6451 47.9988 49.6779 47.686C50.8588 47.3282 51.8278 46.535 52.4064 45.4533C52.8793 44.5685 53.0472 43.5743 52.897 42.5958C54.4929 43.232 56.0327 42.941 57.1019 41.7696C58.1858 40.5825 58.5503 38.7637 58.1449 37.1407C58.2287 37.1107 58.3136 37.0802 58.408 37.0463L58.423 37.0409L58.5324 37.3352C59.0214 38.6509 60.2731 39.4659 61.6007 39.4659C61.9782 39.4659 62.3616 39.4003 62.7354 39.2615L67.8683 37.3553C69.5585 36.7274 70.4228 34.8421 69.7953 33.152ZM9.79213 37.0289C9.67975 37.3769 9.4368 37.6614 9.10758 37.8298C8.77782 37.9982 8.40526 38.0293 8.05785 37.9173L2.84668 36.2354C2.12371 36.0023 1.72518 35.2245 1.95828 34.5015L8.72244 13.5389C8.83455 13.1912 9.0775 12.9067 9.40659 12.7382C9.60551 12.6364 9.82071 12.5846 10.0366 12.5846C10.1777 12.5846 10.3186 12.6064 10.456 12.6507C10.4563 12.6507 10.4563 12.6507 10.4563 12.651L15.6675 14.3322C16.0152 14.4443 16.2997 14.6873 16.4681 15.0164C16.6365 15.3456 16.6676 15.7182 16.5556 16.0661L11.1556 32.8029C11.132 32.8486 11.1091 32.8954 11.0929 32.9459C11.0454 33.0922 11.0088 33.2403 10.9671 33.3875L9.79213 37.0289ZM12.2435 46.2012C11.6819 45.9207 11.2597 45.4114 11.055 44.7672C10.8379 44.0851 10.8971 43.3505 11.2173 42.7518L12.6911 39.9963C12.6914 39.996 12.6918 39.9957 12.6919 39.9953L13.3959 38.679C14.0517 37.4534 15.5714 36.9798 16.8046 37.6022C17.6135 38.1678 18.8269 39.3705 17.9063 41.0915L17.4046 42.0294L15.7259 45.1681C15.0598 46.4084 13.5091 46.8788 12.2435 46.2012ZM20.6177 50.8783C20.2975 51.4775 19.7595 51.9169 19.103 52.1158C18.4468 52.3148 17.7552 52.2476 17.1332 51.9154C16.5716 51.6349 16.1494 51.1253 15.9447 50.4811C15.7276 49.7994 15.7871 49.0647 16.1073 48.4661L17.3941 46.0607L19.0729 42.922C19.3931 42.3231 19.9311 41.8838 20.5872 41.6849C21.2437 41.4854 21.9347 41.5528 22.5342 41.8733C23.1331 42.1935 23.5724 42.7315 23.7714 43.388C23.9703 44.0441 23.9031 44.7357 23.5825 45.335L23.1111 46.2168C23.1109 46.2178 23.1102 46.2186 23.1096 46.2196L21.1943 49.8004C21.1943 49.8006 21.1943 49.8006 21.1941 49.8009L20.6177 50.8783ZM25.8584 54.3423C25.2018 54.5412 24.5109 54.4741 23.8887 54.1419C23.327 53.8613 22.9051 53.352 22.7002 52.708C22.4837 52.0268 22.5422 51.2937 22.8612 50.6955L22.8627 50.6927L24.778 47.1119C24.7781 47.1115 24.7783 47.1111 24.7784 47.1107L24.7795 47.1089C25.1001 46.5112 25.6374 46.0731 26.2926 45.8745C26.9484 45.6746 27.6401 45.7421 28.2392 46.0629C29.4825 46.728 29.9531 48.2809 29.2882 49.5242L28.3306 51.3148L27.4818 52.9018C27.4815 52.9024 27.4811 52.9031 27.4808 52.9036L27.3731 53.105C27.0529 53.7037 26.5146 54.1434 25.8584 54.3423ZM30.5678 57.4476C29.3277 56.7844 28.4404 55.1206 29.1501 53.7938L29.999 52.2067L30 52.2046C30.331 51.5875 30.9194 51.0918 31.615 50.8448C32.3094 50.5978 33.0066 50.6308 33.5786 50.9368C34.8251 51.6031 35.0262 52.1862 35.0686 52.5669C35.1332 53.1423 34.8896 53.9075 34.2797 55.0478C34.2793 55.0487 34.279 55.0497 34.2786 55.0505L33.6605 56.2062C32.6135 58.1654 31.2738 57.8248 30.5678 57.4476ZM39.7545 54.6182C39.3083 55.4695 38.3242 56.054 37.1307 55.44L36.6239 55.1755C36.5401 55.1312 36.4619 55.0901 36.3893 55.0523C36.7723 54.2002 37.0515 53.2744 36.9487 52.3565C36.8328 51.3214 36.2584 50.4581 35.2164 49.7301L38.9418 51.7307C40.1868 52.6049 40.1825 53.8027 39.7545 54.6182ZM55.7046 40.4943C55.0955 41.1622 54.2595 41.2188 53.2191 40.6618L50.5211 39.2189C50.5191 39.2179 50.5174 39.217 50.5154 39.2161C50.4878 39.2014 50.459 39.1929 50.4307 39.1811L41.7309 34.4587C41.2727 34.209 40.6978 34.3796 40.4484 34.839C40.1993 35.2981 40.3693 35.872 40.8287 36.1214L49.7125 40.9437C50.3005 41.2885 50.7372 41.8309 50.9382 42.4932C51.1494 43.1903 51.0783 43.9246 50.7378 44.5612C50.3975 45.1976 49.826 45.6645 49.1288 45.8757C48.4305 46.0867 47.6967 46.0159 47.0608 45.6756L44.3784 44.2408C44.3318 44.2028 44.2815 44.1681 44.2265 44.1387L37.7529 40.6774C37.2916 40.4305 36.7189 40.6053 36.4729 41.0657C36.2266 41.5263 36.4002 42.0994 36.8612 42.3456L43.1721 45.72C43.2189 45.7583 43.2696 45.7931 43.325 45.8227C43.9523 46.158 44.4123 46.7209 44.6204 47.4082C44.8285 48.0952 44.7584 48.8187 44.423 49.4457C44.0876 50.073 43.5245 50.5326 42.8375 50.7411C42.1509 50.9489 41.4269 50.8791 40.7999 50.5437L39.4306 49.8114C39.3617 49.7747 39.29 49.7502 39.2177 49.7317L33.6907 46.764C33.2304 46.5151 32.6567 46.6892 32.4101 47.1498C32.1627 47.6099 32.3355 48.1835 32.7959 48.4304L33.9574 49.0541C33.1688 48.7635 32.3051 48.7085 31.4407 48.9237C31.6849 47.1328 30.8156 45.2952 29.1313 44.3942C28.0963 43.8407 26.9054 43.7202 25.775 44.0543C25.7669 43.6479 25.7029 43.2396 25.5816 42.8391C25.2362 41.6988 24.4704 40.7634 23.4259 40.2048C22.3759 39.6437 21.1997 39.547 20.1352 39.8438C20.117 38.2368 19.0969 36.9004 17.8822 36.0475C17.8406 36.0156 17.7963 35.9868 17.7492 35.9617C15.9356 34.9921 13.7437 35.4111 12.4003 36.846C12.3786 35.8623 12.5131 34.8745 12.7864 33.9078L18.1853 17.1743C20.0104 17.3856 21.699 17.0507 23.3381 16.724C26.0632 16.182 28.6513 15.6669 31.9955 17.4898C31.267 18.0699 30.5341 18.7318 29.8056 19.4678C29.2289 20.051 28.6358 20.6333 28.0572 21.2014C25.9479 23.2731 24.1263 25.0623 23.6054 26.3322C23.4795 26.6391 23.5235 26.9895 23.7214 27.2556C27.4864 32.319 32.0491 30.6008 35.7139 29.2208C38.4614 28.1858 40.8343 27.2917 42.7245 28.7875C42.7602 28.8158 42.7978 28.8414 42.8372 28.8642C43.7399 29.3873 44.9834 30.0013 46.4232 30.7124C49.9042 32.4317 54.6717 34.7865 55.9037 36.659C56.7315 37.9164 56.4689 39.6571 55.7046 40.4943ZM57.3372 35.4212C55.6857 33.1816 51.0306 30.8779 47.2614 29.0166C45.8826 28.3355 44.6875 27.7456 43.8419 27.2599C41.1267 25.1615 38.0367 26.3248 35.0475 27.4505C31.5046 28.7841 28.4239 29.9437 25.6098 26.5958C26.2708 25.608 27.8493 24.0579 29.383 22.5516C29.968 21.977 30.5672 21.3883 31.1505 20.7989C32.1611 19.7782 33.1724 18.9196 34.1584 18.241C38.9236 14.9641 42.4562 16.4406 45.5738 17.7453C47.0314 18.3556 48.5194 18.9785 49.9911 18.9785C50.5317 18.9785 51.0694 18.8798 51.6035 18.6803L57.7641 35.2676C57.6206 35.3192 57.4753 35.3716 57.3372 35.4212ZM67.21 35.5817L62.0771 37.488C61.3627 37.7516 60.5697 37.3882 60.3056 36.6763L52.6366 16.0273C52.5095 15.6849 52.5243 15.3114 52.6782 14.9751C52.8324 14.6389 53.1059 14.3836 53.4483 14.2564L58.5813 12.3501C58.7355 12.2928 58.896 12.2642 59.0564 12.2642C59.2529 12.2642 59.4491 12.307 59.634 12.3916C59.97 12.5456 60.2252 12.8193 60.3524 13.1621L68.0216 33.8106C68.2862 34.5229 67.9219 35.3172 67.21 35.5817Z"
                      fill="url(#paint0_linear_294_12131)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_294_12131"
                        x1="35"
                        y1="10.3721"
                        x2="35"
                        y2="59.6278"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#002A57" />
                        <stop offset="1" stopColor="#FFA500" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="font-primary text-[24px] font-bold leading-[33.6px] text-custom-blue">
                  Fair Economy
                </div>
                <div className="font-secondary text-[16px] leading-[24px] text-custom-lightgray">
                  We advocate for fair policies and practices to create
                  sustainable communities.
                </div>
              </div>
              {/* <div
                className="font-primary text-[14px] leading-[18px] text-left text-custom-orange mt-auto flex items-center cursor-pointer"
                onClick={() => (window.location.href = "/donate")}
              >
                Donate
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.35731 16.1874C8.22969 16.4265 8.29933 16.7311 8.52942 16.8943C8.77868 17.071 9.12233 17.0151 9.29649 16.7695L14.8426 8.94793L15.6947 13.7986L15.7124 13.8712C15.7945 14.1297 16.0578 14.2965 16.3326 14.2527C16.6319 14.2046 16.8323 13.9232 16.7797 13.6247L15.6972 7.46322L15.6798 7.39143C15.6431 7.27488 15.5683 7.17479 15.4705 7.10541C15.412 7.064 15.3457 7.03386 15.2743 7.01713C15.0563 6.96598 14.8313 7.04981 14.7034 7.23017L8.39335 16.1291L8.35731 16.1874ZM8.44057 8.65675C8.49475 8.9555 8.78074 9.15829 9.08023 9.10853L12.4847 8.54748L12.5576 8.53044C12.8162 8.45109 12.9791 8.19162 12.9294 7.91777C12.9024 7.76839 12.8181 7.64354 12.7031 7.562C12.5869 7.4796 12.4406 7.44094 12.2898 7.46599L8.88569 8.02644L8.813 8.0436C8.55476 8.12335 8.39146 8.38329 8.44057 8.65675Z"
                    fill="#FFA500"
                  />
                </svg>
              </div> */}
            </div>
          </div>
        </div>
        {/* Right side button */}
        <div className="flex items-center justify-center w-full mx-auto mt-10">
          <button
            onClick={() => (window.location.href = "/donate")}
            className="w-[152px] h-[48px] px-[16px] py-[0px] gap-[10px] rounded-[30px] bg-custom-blue text-white transition-all duration-300 ease-in flex items-center justify-center"
          >
            Donate
          </button>
        </div>
      </div>

      <div className="w-full max-w-[1440px] pt-[50px] mx-auto">
        <div className="w-full max-w-[1200px] mx-auto flex justify-between items-center mb-[32px] px-4">
          <div>
            <div className="flex items-center mb-[16px]">
              <div className="w-[72px] h-0 border-t-[2px] border-[#FFA500] mr-[24px]"></div>
              <div>
                <h4 className="text-[16px] font-semibold leading-[21.86px] tracking-[2px] text-[#FFA500]">
                  MEET OUT TEAM
                </h4>
              </div>
            </div>

            <div>
              <h2 className="text-[32px] font-semibold leading-[38.4px] text-[#002A57]">
                Our Staffs
              </h2>
            </div>
          </div>

          {/* Right side button */}
          <div className="flex items-center ml-auto">
            <button
              onClick={handleViewMoreClick}
              className="w-[152px] h-[48px] px-[16px] py-[0px] gap-[10px] rounded-[30px] bg-custom-blue text-white transition-all duration-300 ease-in flex items-center justify-center"
            >
              View More
            </button>
          </div>
        </div>
        <div className="w-full max-w-[1200px] mx-auto mt-12 px-4">
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {ourStaffs.map((staff, index) => (
              <div
                key={index}
                className="w-full flex flex-col items-start gap-2 group transition-transform duration-300 ease-in-out transform hover:scale-105 relative"
              >
                <div className="w-full h-[320px] overflow-hidden rounded-[20px] relative">
                  <img
                    src={staff.attributes.headshot.data.attributes.url}
                    alt={staff.attributes.name}
                    className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition duration-500"
                  />
                  <div className="absolute bottom-7 right-4 flex flex-col items-end">
                    <div
                      className={`relative transform transition-all duration-500 ${
                        clickedCardIndex === index
                          ? "translate-y-0 opacity-100"
                          : "translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100"
                      }`}
                    >
                      <button
                        onClick={() => handleSvgClick(index)}
                        className="focus:outline-none w-8 h-8 flex items-center justify-center bg-[#F1AE45] rounded-full"
                      >
                        <span className="block relative w-4 h-4 bg-transparent transition-transform duration-300">
                          {/* Horizontal Line */}
                          <span
                            className={`absolute left-0 top-1/2 w-full h-[1.2px] bg-[#002A57] transform -translate-y-1/2 ${
                              clickedCardIndex === index ? "rotate-45" : ""
                            } transition-transform duration-300`}
                          ></span>
                          {/* Vertical Line */}
                          <span
                            className={`absolute left-1/2 top-0 h-full w-[1.2px] bg-[#002A57] transform -translate-x-1/2 ${
                              clickedCardIndex === index ? "rotate-45" : ""
                            } transition-transform duration-300`}
                          ></span>
                        </span>
                      </button>

                      {/* Box that appears after SVG click */}
                      <div
                        className={`absolute -top-[70px] right-0 w-[30px] h-[61px] bg-white transform ${
                          clickedCardIndex === index
                            ? "translate-y-0 opacity-100"
                            : "translate-y-4 opacity-0"
                        } transition-all duration-500`}
                        style={{
                          padding: "11px 8px",
                          borderRadius: "8px 8px 8px 8px",
                        }}
                      >
                        <div className="flex flex-col items-center">
                          {/* Mail Icon */}
                          <a
                            href={`mailto:${staff.email}`}
                            className="w-[14px] h-[14px]"
                          >
                            {/* Mail SVG */}
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_1656_2629)">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M3.29493 10.5701C4.7249 10.5701 5.93467 11.5129 6.3366 12.8107C6.40722 13.0388 6.36883 13.2656 6.22719 13.4578C6.08555 13.6499 5.8802 13.7537 5.64149 13.7537H0.948399C0.709689 13.7537 0.50431 13.6499 0.362669 13.4578C0.221028 13.2656 0.182638 13.0388 0.253267 12.8107C0.655192 11.5129 1.86499 10.5701 3.29493 10.5701ZM7.37385 0.269456C9.06001 0.475929 10.2595 2.01021 10.053 3.69634C9.84658 5.38249 8.31229 6.58201 6.62614 6.37553C6.10417 6.31163 5.62891 6.12036 5.22748 5.83683L4.28781 6.25093C4.23583 6.27384 4.1783 6.26353 4.13753 6.224C4.09676 6.18446 4.08465 6.12728 4.10592 6.07462L4.49609 5.10873C4.06479 4.50459 3.8496 3.74351 3.94694 2.94862C4.15341 1.2625 5.6877 0.0629837 7.37385 0.269456ZM6.9964 3.02171C6.83029 3.02171 6.69562 3.15638 6.69562 3.3225C6.69562 3.48861 6.83029 3.62328 6.9964 3.62328C7.16251 3.62328 7.29718 3.48861 7.29718 3.3225C7.29718 3.15638 7.16251 3.02171 6.9964 3.02171ZM5.53805 3.02171C5.37193 3.02171 5.23727 3.15638 5.23727 3.3225C5.23727 3.48861 5.37193 3.62328 5.53805 3.62328C5.70419 3.62328 5.83883 3.48861 5.83883 3.3225C5.83883 3.15638 5.70416 3.02171 5.53805 3.02171ZM8.46197 3.02171C8.29586 3.02171 8.16119 3.15638 8.16119 3.3225C8.16119 3.48861 8.29586 3.62328 8.46197 3.62328C8.62808 3.62328 8.76275 3.48861 8.76275 3.3225C8.76275 3.15638 8.62808 3.02171 8.46197 3.02171ZM10.7051 6.92088C11.5941 6.92088 12.3147 7.64152 12.3147 8.5305C12.3147 9.41947 11.5941 10.1401 10.7051 10.1401C9.81614 10.1401 9.0955 9.41947 9.0955 8.5305C9.09547 7.64155 9.81614 6.92088 10.7051 6.92088ZM10.7051 10.5701C12.1351 10.5701 13.3448 11.5129 13.7468 12.8107C13.8174 13.0388 13.779 13.2656 13.6373 13.4578C13.4957 13.6499 13.2904 13.7537 13.0516 13.7537H8.35856C8.11984 13.7537 7.91447 13.6499 7.77283 13.4578C7.63119 13.2656 7.59279 13.0388 7.66342 12.8107C8.06532 11.5129 9.27515 10.5701 10.7051 10.5701ZM3.29496 6.92088C4.18393 6.92088 4.90458 7.64152 4.90458 8.5305C4.90458 9.41947 4.1839 10.1401 3.29496 10.1401C2.40599 10.1401 1.68534 9.41947 1.68534 8.5305C1.68534 7.64155 2.40599 6.92088 3.29496 6.92088Z"
                                  fill="#002A57"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_1656_2629">
                                  <rect width="14" height="14" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </a>

                          {/* LinkedIn Icon */}
                          <a
                            href={staff.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-[14px] h-[14px]"
                            style={{ marginTop: "14px" }}
                          >
                            {/* LinkedIn SVG */}
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.83755 4.90001C8.39045 4.89848 7.94745 4.98512 7.53387 5.15498C7.1203 5.32483 6.74427 5.57457 6.42731 5.8899C6.11036 6.20523 5.85869 6.57997 5.68671 6.99266C5.51473 7.40536 5.42581 7.84792 5.42505 8.29501V11.725C5.42505 11.8643 5.48036 11.9978 5.57882 12.0962C5.67727 12.1947 5.81081 12.25 5.95005 12.25H7.17505C7.31429 12.25 7.44782 12.1947 7.54628 12.0962C7.64474 11.9978 7.70005 11.8643 7.70005 11.725V8.29501C7.69993 8.136 7.73333 7.97874 7.79807 7.8335C7.8628 7.68826 7.95742 7.55829 8.07575 7.45206C8.19408 7.34584 8.33348 7.26575 8.48484 7.217C8.6362 7.16826 8.79613 7.15197 8.95422 7.16918C9.23772 7.20489 9.49826 7.3434 9.68642 7.55845C9.87459 7.77349 9.97729 8.05011 9.97505 8.33585V11.725C9.97505 11.8643 10.0304 11.9978 10.1288 12.0962C10.2273 12.1947 10.3608 12.25 10.5 12.25H11.725C11.8643 12.25 11.9978 12.1947 12.0963 12.0962C12.1947 11.9978 12.25 11.8643 12.25 11.725V8.29501C12.2493 7.84792 12.1604 7.40536 11.9884 6.99266C11.8164 6.57997 11.5647 6.20523 11.2478 5.8899C10.9308 5.57457 10.5548 5.32483 10.1412 5.15498C9.72765 4.98512 9.28464 4.89848 8.83755 4.90001Z"
                                fill="#002A57"
                              />
                              <path
                                d="M3.85 5.42499H2.275C1.98505 5.42499 1.75 5.66004 1.75 5.94999V11.725C1.75 12.0149 1.98505 12.25 2.275 12.25H3.85C4.13995 12.25 4.375 12.0149 4.375 11.725V5.94999C4.375 5.66004 4.13995 5.42499 3.85 5.42499Z"
                                fill="#002A57"
                              />
                              <path
                                d="M3.0625 4.375C3.78737 4.375 4.375 3.78737 4.375 3.0625C4.375 2.33763 3.78737 1.75 3.0625 1.75C2.33763 1.75 1.75 2.33763 1.75 3.0625C1.75 3.78737 2.33763 4.375 3.0625 4.375Z"
                                fill="#002A57"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full font-primary text-xl sm:text-2xl font-semibold leading-snug text-center sm:text-left text-[#002A57]">
                  {staff.attributes.name}
                </div>
                <div className="w-full font-secondary text-base sm:text-lg font-normal leading-snug text-center sm:text-left text-[#002A57]">
                  {staff.attributes.role}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative w-full max-w-[1200px] h-auto px-4 py-12 mx-auto box-border bg-white">
        <div className="flex flex-col items-center gap-8">
          {/* Header Section */}
          <div className="flex flex-col items-center">
            <div className="text-base font-semibold leading-6 tracking-wider text-center text-custom-orange">
              FREQUENTLY ASKED QUESTION
            </div>
            <div className="mt-2 sm:mt-6 w-full sm:w-[534px] text-2xl sm:text-4xl font-semibold leading-tight text-center text-custom-blue">
              You must have Questions
            </div>
          </div>

          {/* FAQ Items */}
          <div className="w-full max-w-[1200px] flex flex-col gap-6">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className={`w-full transition-all duration-300 border ${
                  openIndex === index
                    ? "border-custom-orange"
                    : "border-gray-200"
                } p-6 sm:p-6 flex flex-col cursor-pointer`}
                onClick={() => toggleOpen(index)}
              >
                {/* Question and Icon */}
                <div className="flex justify-between items-center">
                  <div
                    className={`flex-1 text-xl sm:text-2xl font-light leading-tight text-left transition-colors duration-300 ${
                      openIndex === index
                        ? "text-custom-blue"
                        : "text-black-500"
                    }`}
                  >
                    {item.question}
                  </div>
                  <div
                    className={`ml-4 flex-shrink-0 transform transition-transform duration-500 ease-in-out ${
                      openIndex === index ? "rotate-0" : "rotate-90"
                    }`}
                  >
                    {openIndex === index ? (
                      // Minus Icon
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 12H19"
                          stroke="#FFA500"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      // Plus Icon
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 12.998H13V17.998C13 18.2633 12.8946 18.5176 12.7071 18.7052C12.5196 18.8927 12.2652 18.998 12 18.998C11.7348 18.998 11.4804 18.8927 11.2929 18.7052C11.1054 18.5176 11 18.2633 11 17.998V12.998H6C5.73478 12.998 5.48043 12.8927 5.29289 12.7052C5.10536 12.5176 5 12.2633 5 11.998C5 11.7328 5.10536 11.4785 5.29289 11.2909C5.48043 11.1034 5.73478 10.998 6 10.998H11V5.99805C11 5.73283 11.1054 5.47848 11.2929 5.29094C11.4804 5.1034 11.7348 4.99805 12 4.99805C12.2652 4.99805 12.5196 5.1034 12.7071 5.29094C12.8946 5.47848 13 5.73283 13 5.99805V10.998H18C18.2652 10.998 18.5196 11.1034 18.7071 11.2909C18.8946 11.4785 19 11.7328 19 11.998C19 12.2633 18.8946 12.5176 18.7071 12.7052C18.5196 12.8927 18.2652 12.998 18 12.998Z"
                          fill="#FFA500"
                        />
                      </svg>
                    )}
                  </div>
                </div>

                {/* Answer Section */}
                <div
                  className={`text-sm sm:text-[15.88px] leading-6 sm:leading-6 text-gray-500 transition-all duration-300 overflow-hidden ${
                    openIndex === index
                      ? "opacity-100 max-h-screen mt-4 sm:mt-6"
                      : "opacity-0 max-h-0 mt-0"
                  }`}
                >
                  {item.answer}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Newsletter />
    </>
  );
};

export default AboutUs;
